var ua = Object.defineProperty;
var ha = (e, a, t) => a in e ? ua(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var me = (e, a, t) => (ha(e, typeof a != "symbol" ? a + "" : a, t), t);
import { jsx as u, jsxs as F } from "react/jsx-runtime";
import _, { createContext as Be, Component as fa, createElement as ue, useRef as ga, useCallback as pa, forwardRef as mt, useState as Ft, Suspense as ya, useEffect as va } from "react";
import * as ba from "@tanstack/react-query";
import { useSuspenseInfiniteQuery as Ma, dehydrate as wa, hydrate as Pa, QueryClientProvider as ka, QueryErrorResetBoundary as Ca, QueryClient as Ea } from "@tanstack/react-query";
import { I18nextProvider as xa, useTranslation as Da } from "react-i18next";
import "i18next";
const Ta = Be(null), Je = {
  didCatch: !1,
  error: null
};
class Na extends fa {
  constructor(a) {
    super(a), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Je;
  }
  static getDerivedStateFromError(a) {
    return {
      didCatch: !0,
      error: a
    };
  }
  resetErrorBoundary() {
    const {
      error: a
    } = this.state;
    if (a !== null) {
      for (var t, n, r = arguments.length, o = new Array(r), i = 0; i < r; i++)
        o[i] = arguments[i];
      (t = (n = this.props).onReset) === null || t === void 0 || t.call(n, {
        args: o,
        reason: "imperative-api"
      }), this.setState(Je);
    }
  }
  componentDidCatch(a, t) {
    var n, r;
    (n = (r = this.props).onError) === null || n === void 0 || n.call(r, a, t);
  }
  componentDidUpdate(a, t) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: r
    } = this.props;
    if (n && t.error !== null && _a(a.resetKeys, r)) {
      var o, i;
      (o = (i = this.props).onReset) === null || o === void 0 || o.call(i, {
        next: r,
        prev: a.resetKeys,
        reason: "keys"
      }), this.setState(Je);
    }
  }
  render() {
    const {
      children: a,
      fallbackRender: t,
      FallbackComponent: n,
      fallback: r
    } = this.props, {
      didCatch: o,
      error: i
    } = this.state;
    let s = a;
    if (o) {
      const l = {
        error: i,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof t == "function")
        s = t(l);
      else if (n)
        s = ue(n, l);
      else if (r !== void 0)
        s = r;
      else
        throw i;
    }
    return ue(Ta.Provider, {
      value: {
        didCatch: o,
        error: i,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function _a() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== a.length || e.some((t, n) => !Object.is(t, a[n]));
}
var Sa = /* @__PURE__ */ Be({}), It = "id";
function Wa(e) {
  return e === void 0 && (e = It), (e ? e + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var $a = /* @__PURE__ */ Be(Wa);
function Oa(e) {
  var a = e.children, t = e.prefix, n = t === void 0 ? It : t, r = ga(0), o = pa(function(i) {
    return i === void 0 && (i = n), (i ? i + "-" : "") + ++r.current;
  }, [n]);
  return /* @__PURE__ */ ue($a.Provider, {
    value: o
  }, a);
}
function za(e) {
  var a = e.children, t = e.unstable_system;
  return /* @__PURE__ */ ue(Sa.Provider, {
    value: t
  }, a);
}
var La = {};
function Aa(e) {
  var a = e.unstable_prefix, t = e.unstable_system, n = t === void 0 ? La : t, r = e.children;
  return /* @__PURE__ */ ue(Oa, {
    prefix: a
  }, /* @__PURE__ */ ue(za, {
    unstable_system: n
  }, r));
}
const ja = ({ children: e, i18nInstance: a }) => /* @__PURE__ */ u(xa, { i18n: a, children: e }), Ha = (e = "label") => {
  const a = Array.isArray(e) ? e : [e];
  return Da(a);
}, Ra = () => {
  const { t: e } = Ha("label");
  return /* @__PURE__ */ u("div", { "data-testid": "default-loading-fallback", children: e("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
}, Fa = "application/json", Yt = "Content-Type", Te = Symbol(), qt = Symbol();
function ut(e = {}) {
  var a;
  const t = e instanceof Array ? Object.fromEntries(e) : e;
  return (a = Object.entries(t).find(([n]) => n.toLowerCase() === Yt.toLowerCase())) === null || a === void 0 ? void 0 : a[1];
}
function ht(e) {
  return /^application\/.*json.*/.test(e);
}
const Pe = function(e, a, t = !1) {
  return Object.entries(a).reduce((n, [r, o]) => {
    const i = e[r];
    return Array.isArray(i) && Array.isArray(o) ? n[r] = t ? [...i, ...o] : o : typeof i == "object" && typeof o == "object" ? n[r] = Pe(i, o, t) : n[r] = o, n;
  }, { ...e });
}, Se = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, a = !0, t = !1, ...n) {
    const r = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (a && !r)
      throw new Error(e + " is not defined");
    return t && r ? new r(...n) : r;
  }
};
function Ia(e, a = !1) {
  Se.options = a ? e : Pe(Se.options, e);
}
function Ya(e, a = !1) {
  Se.polyfills = a ? e : Pe(Se.polyfills, e);
}
function qa(e) {
  Se.errorType = e;
}
const Ba = (e) => (a) => e.reduceRight((t, n) => n(t), a) || a;
class Bt extends Error {
}
const Xa = (e) => {
  const a = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((h, k) => k.beforeRequest && k.beforeRequest(h, e._options, a) || h, e);
  const { _url: t, _options: n, _config: r, _catchers: o, _resolvers: i, _middlewares: s, _addons: l } = e, c = new Map(o), d = Pe(r.options, n);
  let p = t;
  const E = Ba(s)((h, k) => (p = h, r.polyfill("fetch")(h, k)))(t, d), P = new Error(), N = E.catch((h) => {
    throw { [Te]: h };
  }).then((h) => {
    var k;
    if (!h.ok) {
      const x = new Bt();
      if (x.cause = P, x.stack = x.stack + `
CAUSE: ` + P.stack, x.response = h, x.status = h.status, x.url = p, h.type === "opaque")
        throw x;
      const H = r.errorType === "json" || ((k = h.headers.get("Content-Type")) === null || k === void 0 ? void 0 : k.split(";")[0]) === "application/json";
      return (r.errorType ? H ? h.text() : h[r.errorType]() : Promise.resolve(h.body)).then((X) => {
        if (x.message = typeof X == "string" ? X : h.statusText, X)
          if (H && typeof X == "string") {
            x.text = X;
            try {
              x.json = JSON.parse(X);
            } catch {
            }
          } else
            x[r.errorType] = X;
        throw x;
      });
    }
    return h;
  }), O = (h) => h.catch((k) => {
    const x = Object.prototype.hasOwnProperty.call(k, Te), H = x ? k[Te] : k, B = (H == null ? void 0 : H.status) && c.get(H.status) || c.get(H == null ? void 0 : H.name) || x && c.has(Te) && c.get(Te);
    if (B)
      return B(H, e);
    const X = c.get(qt);
    if (X)
      return X(H, e);
    throw H;
  }), z = (h) => (k) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ O(h ? N.then((x) => x && x[h]()).then((x) => k ? k(x) : x) : N.then((x) => k ? k(x) : x)), S = {
    _wretchReq: e,
    _fetchReq: E,
    _sharedState: a,
    res: z(null),
    json: z("json"),
    blob: z("blob"),
    formData: z("formData"),
    arrayBuffer: z("arrayBuffer"),
    text: z("text"),
    error(h, k) {
      return c.set(h, k), this;
    },
    badRequest(h) {
      return this.error(400, h);
    },
    unauthorized(h) {
      return this.error(401, h);
    },
    forbidden(h) {
      return this.error(403, h);
    },
    notFound(h) {
      return this.error(404, h);
    },
    timeout(h) {
      return this.error(408, h);
    },
    internalError(h) {
      return this.error(500, h);
    },
    fetchError(h) {
      return this.error(Te, h);
    }
  }, W = l.reduce((h, k) => ({
    ...h,
    ...typeof k.resolver == "function" ? k.resolver(h) : k.resolver
  }), S);
  return i.reduce((h, k) => k(h, e), W);
}, Va = {
  _url: "",
  _options: {},
  _config: Se,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, a = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: a ? e : Pe(this._config.polyfills, e)
      }
    };
  },
  url(e, a = !1) {
    if (a)
      return { ...this, _url: e };
    const t = this._url.split("?");
    return {
      ...this,
      _url: t.length > 1 ? t[0] + e + "?" + t[1] : this._url + e
    };
  },
  options(e, a = !1) {
    return { ...this, _options: a ? e : Pe(this._options, e) };
  },
  headers(e) {
    const a = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: Pe(this._options, { headers: a }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [Yt]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, a) {
    const t = new Map(this._catchers);
    return t.set(e, a), { ...this, _catchers: t };
  },
  catcherFallback(e) {
    return this.catcher(qt, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, a = !1) {
    return { ...this, _resolvers: a ? [e] : [...this._resolvers, e] };
  },
  defer(e, a = !1) {
    return {
      ...this,
      _deferred: a ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, a = !1) {
    return {
      ...this,
      _middlewares: a ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, a = "", t = null) {
    let n = this.url(a).options({ method: e });
    const r = ut(n._options.headers), o = this._config.polyfill("FormData", !1), i = typeof t == "object" && !(o && t instanceof o) && (!n._options.headers || !r || ht(r));
    return n = t ? i ? n.json(t, r) : n.body(t) : n, Xa(n._deferred.reduce((s, l) => l(s, s._url, s._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, a = "") {
    return this.fetch("PUT", a, e);
  },
  post(e, a = "") {
    return this.fetch("POST", a, e);
  },
  patch(e, a = "") {
    return this.fetch("PATCH", a, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, a) {
    const t = ut(this._options.headers);
    return this.content(a || ht(t) && t || Fa).body(JSON.stringify(e));
  }
};
function ke(e = "", a = {}) {
  return { ...Va, _url: e, _options: a };
}
ke.default = ke;
ke.options = Ia;
ke.errorType = qa;
ke.polyfills = Ya;
ke.WretchError = Bt;
class Ja extends Error {
  constructor(t, n, r, o, i) {
    super(t);
    me(this, "statusCode");
    me(this, "endpoint");
    me(this, "args");
    me(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = r, this.args = o, this.response = i;
  }
}
class st extends Ja {
  constructor(a, t, n, r) {
    super(`Client error ${a} occurred while fetching ${t}`, a, t, n, r), this.name = "Api4xxError";
  }
}
class Ua extends st {
  constructor(a, t, n) {
    super(404, a, t, n), this.name = "Api404Error";
  }
}
class Qa extends st {
  constructor(a, t, n) {
    super(400, a, t, n), this.name = "Api400Error";
  }
}
class Za {
  constructor(a = {}) {
    me(this, "logger");
    me(this, "notFoundLogLevel");
    me(this, "badRequestLogLevel");
    me(this, "other4xxLogLevel");
    this.logger = a.logger, this.notFoundLogLevel = a.notFoundLogLevel || "info", this.badRequestLogLevel = a.badRequestLogLevel || "warn", this.other4xxLogLevel = a.other4xxLogLevel || "warn";
  }
  log(a, t, n) {
    this.logger && this.logger[a](t, n);
  }
  async handleApiError(a, t, n) {
    if (!(a instanceof Response))
      throw a;
    const { status: r } = a;
    if (r === 404) {
      const o = new Ua(t, n, a);
      return this.log(this.notFoundLogLevel, o.message, {
        args: n,
        endpoint: t,
        statusCode: r
      }), null;
    }
    if (r === 400) {
      const o = new Qa(t, n, a);
      return this.log(this.badRequestLogLevel, o.message, {
        args: n,
        endpoint: t,
        statusCode: r
      }), null;
    }
    if (r >= 400 && r < 500) {
      const o = new st(r, t, n, a);
      return this.log(this.other4xxLogLevel, o.message, {
        args: n,
        endpoint: t,
        statusCode: r
      }), null;
    }
    throw a;
  }
}
const Ga = (e, a) => {
  const t = new Za(a);
  return e.catcher(404, async (n) => (await t.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await t.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await t.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await t.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await t.handleApiError(n.response, n.url), null;
    throw n;
  });
};
/*! js-cookie v3.0.8 | MIT */
function Ie(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var n in t)
      n !== "__proto__" && (e[n] = t[n]);
  }
  return e;
}
var Ka = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function nt(e, a) {
  function t(r, o, i) {
    if (!(typeof document > "u")) {
      i = Ie({}, a, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), r = encodeURIComponent(r).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in i)
        i[l] && (s += "; " + l, i[l] !== !0 && (s += "=" + i[l].split(";")[0]));
      return document.cookie = r + "=" + e.write(o, r) + s;
    }
  }
  function n(r) {
    if (!(typeof document > "u" || arguments.length && !r)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], i = {}, s = 0; s < o.length; s++) {
        var l = o[s].split("="), c = l.slice(1).join("=");
        try {
          var d = decodeURIComponent(l[0]);
          if (d in i || (i[d] = e.read(c, d)), r === d)
            break;
        } catch {
        }
      }
      return r ? i[r] : i;
    }
  }
  return Object.create(
    {
      set: t,
      get: n,
      remove: function(r, o) {
        t(
          r,
          "",
          Ie({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(r) {
        return nt(this.converter, Ie({}, this.attributes, r));
      },
      withConverter: function(r) {
        return nt(Ie({}, this.converter, r), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(a) },
      converter: { value: Object.freeze(e) }
    }
  );
}
nt(Ka, { path: "/" });
Be(void 0);
const Xt = (e) => {
  typeof window < "u" && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
    ...e
  }));
}, Vt = {
  ARTICLE_CLICK: "article_click",
  HERO_ARTICLE_VIEW: "hero_article_view"
}, en = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx`, Jt = (e, a) => {
  const t = new URL(e);
  return t.searchParams.set("fm", "webp"), t.searchParams.set("w", a.toString()), t.toString();
}, tn = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function Ae(e, a) {
  if (!a && typeof window > "u")
    return e;
  try {
    const t = new URL(a || window.location.href), n = new URLSearchParams(t.search), r = [];
    for (const s of tn) {
      const l = n.get(s);
      l !== null && r.push([s, l]);
    }
    if (r.length === 0)
      return e;
    const o = e.startsWith("http://") || e.startsWith("https://"), i = o ? new URL(e) : new URL(e, t.origin);
    for (const [s, l] of r)
      i.searchParams.has(s) || i.searchParams.set(s, l);
    return o ? i.toString() : i.pathname + i.search + i.hash;
  } catch {
    return e;
  }
}
const an = (e) => Array.isArray(e) ? e.join(",") : e ?? "", Ut = async (e = en(), a, t) => {
  const { countryCode: n, limit: r, offset: o, repub: i, subdivision: s, topics: l, type: c } = a, d = new URL(`${e}/v2/articles`);
  c && d.searchParams.append("articleType", c), r && d.searchParams.append("limit", r.toString()), o && d.searchParams.append("offset", o.toString());
  const p = an(l);
  return p && d.searchParams.append("topics", p), Ga(
    ke(d.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "country-code": n,
        repub: i,
        ...s ? { subdivision: s } : {},
        ...(t == null ? void 0 : t.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    t
  ).get().notFound(() => null).json();
}, Qt = ({
  countryCode: e,
  limit: a,
  repub: t,
  subdivision: n,
  topics: r,
  type: o
}) => ["more-articles", t, e, n, r, o, a];
var nn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Zt(e) {
  var a, t, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (a = 0; a < r; a++)
        e[a] && (t = Zt(e[a])) && (n && (n += " "), n += t);
    } else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function J() {
  for (var e, a, t = 0, n = "", r = arguments.length; t < r; t++)
    (e = arguments[t]) && (a = Zt(e)) && (n && (n += " "), n += a);
  return n;
}
const ft = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, gt = J, on = (e, a) => (t) => {
  var n;
  if ((a == null ? void 0 : a.variants) == null)
    return gt(e, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
  const { variants: r, defaultVariants: o } = a, i = Object.keys(r).map((c) => {
    const d = t == null ? void 0 : t[c], p = o == null ? void 0 : o[c];
    if (d === null)
      return null;
    const E = ft(d) || ft(p);
    return r[c][E];
  }), s = t && Object.entries(t).reduce((c, d) => {
    let [p, E] = d;
    return E === void 0 || (c[p] = E), c;
  }, {}), l = a == null || (n = a.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((c, d) => {
    let { class: p, className: E, ...P } = d;
    return Object.entries(P).every((N) => {
      let [O, z] = N;
      return Array.isArray(z) ? z.includes({
        ...o,
        ...s
      }[O]) : {
        ...o,
        ...s
      }[O] === z;
    }) ? [
      ...c,
      p,
      E
    ] : c;
  }, []);
  return gt(e, i, l, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
}, sn = "_icon_8pxtp_1", ne = {
  icon: sn,
  "size--xs": "_size--xs_8pxtp_5",
  "size--s": "_size--s_8pxtp_10",
  "size--m": "_size--m_8pxtp_15",
  "size--l": "_size--l_8pxtp_20",
  "size--xl": "_size--xl_8pxtp_25",
  "size--xxl": "_size--xxl_8pxtp_30",
  "size--xxxl": "_size--xxxl_8pxtp_35",
  "color--black": "_color--black_8pxtp_40",
  "color--white": "_color--white_8pxtp_44",
  "color--green": "_color--green_8pxtp_48",
  "color--blue": "_color--blue_8pxtp_52",
  "color--grey": "_color--grey_8pxtp_56"
}, G = on(ne.icon, {
  variants: {
    color: {
      black: ne["color--black"],
      white: ne["color--white"],
      blue: ne["color--blue"],
      green: ne["color--green"],
      grey: ne["color--grey"]
    },
    size: {
      xs: ne["size--xs"],
      s: ne["size--s"],
      m: ne["size--m"],
      l: ne["size--l"],
      xl: ne["size--xl"],
      xxl: ne["size--xxl"],
      xxxl: ne["size--xxxl"]
    }
  },
  defaultVariants: {
    color: "white",
    size: "m"
  }
}), dn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 11, fill: "none", viewBox: "0 0 12 11", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "m.136 5.702 4.091 4.772c.178.249.546.248.773.045a.56.56 0 0 0 .045-.781L1.747 5.895h9.707c.301 0 .546-.251.546-.561s-.244-.561-.546-.561H1.747L5.045.93c.216-.215.156-.584-.071-.788s-.569-.189-.747.051L.136 4.965A.56.56 0 0 0 0 5.334c.01.119.059.279.136.368",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
dn.displayName = "Arrow";
const ln = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M16.5 1.838v14.999a.46.46 0 0 1-.248.413l-.18.046a.45.45 0 0 1-.316-.115l-1.735-1.631-.225.207v3.767a.46.46 0 0 1-.271.413l-.18.046a.45.45 0 0 1-.316-.115l-1.713-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.78-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.758-1.631-1.735 1.631a.44.44 0 0 1-.487.097.46.46 0 0 1-.279-.418V4.548c0-1.015.807-1.838 1.803-1.838h.901v-.873C3.204.823 4.011 0 5.007 0h9.69c.996 0 1.803.823 1.803 1.838m-4.868 15.458 1.262 1.195V4.525a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v13.966l1.284-1.195a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.444.444 0 0 1 .609 0zm2.682-2.71 1.284 1.194-.023-13.943a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v.85h7.887c.996 0 1.803.823 1.803 1.838v9.992a.445.445 0 0 1 .541.069M4.976 8h3.048c.263 0 .476-.224.476-.5S8.287 7 8.024 7H4.976c-.263 0-.476.224-.476.5s.213.5.476.5m-.06 2h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0 3h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5z",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
ln.displayName = "Betslip";
const rt = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 9, fill: "none", viewBox: "0 0 13 9", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 5.188 10.781.86 12.22 2.3 6.455 8.062.691 2.3 2.13.86z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
rt.displayName = "ChevronDown";
const cn = _.forwardRef(
  ({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
    const i = J(
      G({
        color: e,
        size: a
      }),
      n
    ), s = {
      "--opacity": t
    };
    return _.cloneElement(
      /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref: o, ...r, children: /* @__PURE__ */ F("g", { fill: "currentColor", children: [
        /* @__PURE__ */ u("path", { d: "M12 17.5a1 1 0 0 1-.707-.293l-9-9a1 1 0 1 1 1.414-1.414l9 9A1 1 0 0 1 12 17.5" }),
        /* @__PURE__ */ u("path", { d: "M12 17.5a1 1 0 0 1-.707-1.707l9-9a1 1 0 1 1 1.414 1.414l-9 9A1 1 0 0 1 12 17.5" })
      ] }) }),
      {
        role: "presentation",
        focusable: !1,
        className: i,
        "aria-hidden": !0,
        style: s,
        ...r
      }
    );
  }
);
cn.displayName = "ChevronDownLight";
const mn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 8, fill: "none", viewBox: "0 0 13 8", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 3.017 2.129 7.344.69 5.906 6.455.143l5.764 5.763-1.438 1.438z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
mn.displayName = "ChevronUp";
const un = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 13, fill: "none", viewBox: "0 0 13 13", ref: o, ...r, children: [
      /* @__PURE__ */ u("path", { fill: "currentColor", d: "M1.638.33 12.75 11.48l-1.265 1.27L.373 1.6z" }),
      /* @__PURE__ */ u("path", { fill: "currentColor", d: "M.25 11.379 11.34.25l1.265 1.27-11.09 11.128z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
un.displayName = "Cross";
const hn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M15.344 17.778a.75.75 0 0 0-.75-.75h-5.16a.75.75 0 1 0 0 1.5h5.16a.75.75 0 0 0 .75-.75m2.206-4a.75.75 0 0 0-.75-.75H7.204a.75.75 0 1 0 0 1.5H16.8a.75.75 0 0 0 .75-.75m2.45-4a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 .75-.75m2-4a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h18.5a.75.75 0 0 0 .75-.75"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
hn.displayName = "Filter";
const fn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, fill: "none", viewBox: "0 0 15 15", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 13.5a6 6 0 0 0 4.243-1.757A6 6 0 0 0 13.5 7.5a6 6 0 0 0-1.757-4.243A6 6 0 0 0 7.5 1.5a6 6 0 0 0-6 6 6 6 0 0 0 6 6m0 1.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 1 1 0 15m-.75-8.25v4.5h1.5v-4.5zm0-3h1.5v1.5h-1.5z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
fn.displayName = "Info";
const gn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 17 16", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M1.423 0a.923.923 0 1 0 0 1.846h14.154a.923.923 0 1 0 0-1.846zM.5 7.692c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423A.923.923 0 0 1 .5 7.692m0 6.769c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423a.923.923 0 0 1-.923-.923",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
gn.displayName = "Menu";
const pn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ F(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        fill: "currentColor",
        viewBox: "0 0 19 18",
        ref: o,
        ...r,
        children: [
          /* @__PURE__ */ u("path", { d: "m6.361 11.888.359-.84a.4.4 0 0 1 .229-.222.4.4 0 0 1 .125-.022q.098 0 .185.049c.546.306 1.279.49 1.961.49.801 0 1.383-.345 1.383-.818 0-.306-.169-.676-1.415-1.102-1.35-.446-2.725-1.097-2.725-2.557 0-1.108.767-1.975 2.052-2.317l.195-.052v-.916c0-.224.177-.408.39-.408h.923a.4.4 0 0 1 .39.408v.823l.229.03a4.6 4.6 0 0 1 1.482.432c.094.047.166.129.2.232s.031.216-.013.312l-.372.829a.39.39 0 0 1-.354.235.4.4 0 0 1-.161-.038c-.242-.118-.809-.388-1.714-.388-.822 0-1.188.334-1.188.667 0 .372.382.624 1.578 1.039 1.274.438 2.575 1.097 2.575 2.683 0 .856-.564 2.008-2.156 2.429l-.195.055v.949c0 .227-.177.41-.39.41h-.939a.4.4 0 0 1-.39-.41V13l-.231-.025c-.718-.085-1.394-.29-1.849-.566a.42.42 0 0 1-.163-.522z" }),
          /* @__PURE__ */ u(
            "path",
            {
              d: "M18.228 8.727a8.73 8.73 0 0 1-8.727 8.727A8.73 8.73 0 0 1 .773 8.727 8.73 8.73 0 0 1 9.501 0a8.73 8.73 0 0 1 8.727 8.727m-1.091 0c0 4.382-3.255 7.636-7.636 7.636s-7.636-3.255-7.636-7.636S5.12 1.091 9.501 1.091s7.636 3.255 7.636 7.636",
              fillRule: "evenodd"
            }
          )
        ]
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
pn.displayName = "Offers";
const yn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...r, children: [
      /* @__PURE__ */ u(
        "path",
        {
          stroke: "currentColor",
          d: "M8.62 12v2.5M1 7.927v10.391h15.24V7.928zm2.77 0C3.77 3.771 3.77 1 8.62 1s4.85 2.77 4.85 6.927z"
        }
      ),
      /* @__PURE__ */ u("path", { stroke: "currentColor", d: "M8.62 12.855a.693.693 0 1 0 0-1.386.693.693 0 0 0 0 1.386Z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
yn.displayName = "Padlock";
const vn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 20, fill: "none", viewBox: "0 0 12 20", ref: o, ...r, children: /* @__PURE__ */ u("path", { stroke: "currentColor", d: "M4.9 11.119H1L8.8 1 6.85 8.738h3.9l-7.8 10.119z", strokeLinejoin: "round" }) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
vn.displayName = "Picks";
const bn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 19, fill: "none", viewBox: "0 0 19 19", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M9.048.949a.5.5 0 0 1 .903 0l2.45 5.151a.5.5 0 0 0 .387.281l5.656.738a.5.5 0 0 1 .279.859L14.581 11.9a.5.5 0 0 0-.148.455l1.046 5.607a.5.5 0 0 1-.731.531l-5.009-2.727a.5.5 0 0 0-.478 0l-5.009 2.727a.5.5 0 0 1-.731-.531l1.046-5.607a.5.5 0 0 0-.148-.455L.277 7.978a.5.5 0 0 1 .279-.859l5.656-.738a.5.5 0 0 0 .387-.281z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
bn.displayName = "Star";
const Mn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 20, fill: "none", viewBox: "0 0 22 20", ref: o, ...r, children: /* @__PURE__ */ u(
      "path",
      {
        stroke: "currentColor",
        d: "M15.965 4.968c0 2.372-2.081 4.368-4.743 4.368S6.478 7.34 6.478 4.968 8.56.6 11.222.6s4.743 1.996 4.743 4.368ZM15.318 10.857c.174-.116.314-.182.435-.205 1.448-.273 2.575.594 3.49 2.15.906 1.543 1.472 3.573 1.799 5.122.16.758-.429 1.476-1.275 1.476H1.863c-.75 0-1.265-.556-1.207-1.185.222-2.425 1.23-6.34 5.288-7.684.275-.091.607-.059.935.095 1.852.867 3.42 1.291 4.805 1.31 1.4.02 2.577-.374 3.634-1.079Z",
        strokeWidth: 1.2
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
Mn.displayName = "Account";
const wn = _.forwardRef(({ color: e, size: a, opacity: t = 1, className: n, ...r }, o) => {
  const i = J(
    G({
      color: e,
      size: a
    }),
    n
  ), s = {
    "--opacity": t
  };
  return _.cloneElement(
    /* @__PURE__ */ u(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12.78,
        height: 9.58,
        fill: "none",
        viewBox: "0 0 12.78 9.58",
        ref: o,
        ...r,
        children: /* @__PURE__ */ u("path", { fill: "currentColor", d: "m10.538 0 1.637 1.678-7.987 7.795-4.188-4L1.62 3.78l2.55 2.436z" })
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: i,
      "aria-hidden": !0,
      style: s,
      ...r
    }
  );
});
wn.displayName = "Check";
var Gt = { exports: {} };
(function(e, a) {
  (function(t, n) {
    e.exports = n(_);
  })(nn, (t) => (() => {
    var n = { 703: (s, l, c) => {
      var d = c(414);
      function p() {
      }
      function E() {
      }
      E.resetWarningCache = p, s.exports = function() {
        function P(z, S, W, h, k, x) {
          if (x !== d) {
            var H = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw H.name = "Invariant Violation", H;
          }
        }
        function N() {
          return P;
        }
        P.isRequired = P;
        var O = { array: P, bigint: P, bool: P, func: P, number: P, object: P, string: P, symbol: P, any: P, arrayOf: N, element: P, elementType: P, instanceOf: N, node: P, objectOf: N, oneOf: N, oneOfType: N, shape: N, exact: N, checkPropTypes: E, resetWarningCache: p };
        return O.PropTypes = O, O;
      };
    }, 697: (s, l, c) => {
      s.exports = c(703)();
    }, 414: (s) => {
      s.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, 98: (s) => {
      s.exports = t;
    } }, r = {};
    function o(s) {
      var l = r[s];
      if (l !== void 0)
        return l.exports;
      var c = r[s] = { exports: {} };
      return n[s](c, c.exports, o), c.exports;
    }
    o.n = (s) => {
      var l = s && s.__esModule ? () => s.default : () => s;
      return o.d(l, { a: l }), l;
    }, o.d = (s, l) => {
      for (var c in l)
        o.o(l, c) && !o.o(s, c) && Object.defineProperty(s, c, { enumerable: !0, get: l[c] });
    }, o.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l), o.r = (s) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
    };
    var i = {};
    return (() => {
      o.r(i), o.d(i, { default: () => Xe });
      var s = o(98), l = o.n(s), c = o(697), d = o.n(c);
      function p() {
        return p = Object.assign ? Object.assign.bind() : function(y) {
          for (var f = 1; f < arguments.length; f++) {
            var D = arguments[f];
            for (var T in D)
              Object.prototype.hasOwnProperty.call(D, T) && (y[T] = D[T]);
          }
          return y;
        }, p.apply(this, arguments);
      }
      var E = function(y) {
        var f = y.pageClassName, D = y.pageLinkClassName, T = y.page, se = y.selected, V = y.activeClassName, ee = y.activeLinkClassName, g = y.getEventListener, m = y.pageSelectedHandler, L = y.href, v = y.extraAriaContext, C = y.pageLabelBuilder, $ = y.rel, Y = y.ariaLabel || "Page " + T + (v ? " " + v : ""), U = null;
        return se && (U = "page", Y = y.ariaLabel || "Page " + T + " is your current page", f = f !== void 0 ? f + " " + V : V, D !== void 0 ? ee !== void 0 && (D = D + " " + ee) : D = ee), l().createElement("li", { className: f }, l().createElement("a", p({ rel: $, role: L ? void 0 : "button", className: D, href: L, tabIndex: se ? "-1" : "0", "aria-label": Y, "aria-current": U, onKeyPress: m }, g(m)), C(T)));
      };
      E.propTypes = { pageSelectedHandler: d().func.isRequired, selected: d().bool.isRequired, pageClassName: d().string, pageLinkClassName: d().string, activeClassName: d().string, activeLinkClassName: d().string, extraAriaContext: d().string, href: d().string, ariaLabel: d().string, page: d().number.isRequired, getEventListener: d().func.isRequired, pageLabelBuilder: d().func.isRequired, rel: d().string };
      const P = E;
      function N() {
        return N = Object.assign ? Object.assign.bind() : function(y) {
          for (var f = 1; f < arguments.length; f++) {
            var D = arguments[f];
            for (var T in D)
              Object.prototype.hasOwnProperty.call(D, T) && (y[T] = D[T]);
          }
          return y;
        }, N.apply(this, arguments);
      }
      var O = function(y) {
        var f = y.breakLabel, D = y.breakAriaLabel, T = y.breakClassName, se = y.breakLinkClassName, V = y.breakHandler, ee = y.getEventListener, g = T || "break";
        return l().createElement("li", { className: g }, l().createElement("a", N({ className: se, role: "button", tabIndex: "0", "aria-label": D, onKeyPress: V }, ee(V)), f));
      };
      O.propTypes = { breakLabel: d().oneOfType([d().string, d().node]), breakAriaLabel: d().string, breakClassName: d().string, breakLinkClassName: d().string, breakHandler: d().func.isRequired, getEventListener: d().func.isRequired };
      const z = O;
      function S(y) {
        var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return y ?? f;
      }
      function W(y) {
        return W = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(f) {
          return typeof f;
        } : function(f) {
          return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
        }, W(y);
      }
      function h() {
        return h = Object.assign ? Object.assign.bind() : function(y) {
          for (var f = 1; f < arguments.length; f++) {
            var D = arguments[f];
            for (var T in D)
              Object.prototype.hasOwnProperty.call(D, T) && (y[T] = D[T]);
          }
          return y;
        }, h.apply(this, arguments);
      }
      function k(y, f) {
        for (var D = 0; D < f.length; D++) {
          var T = f[D];
          T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(y, T.key, T);
        }
      }
      function x(y, f) {
        return x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(D, T) {
          return D.__proto__ = T, D;
        }, x(y, f);
      }
      function H(y, f) {
        if (f && (W(f) === "object" || typeof f == "function"))
          return f;
        if (f !== void 0)
          throw new TypeError("Derived constructors may only return object or undefined");
        return B(y);
      }
      function B(y) {
        if (y === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return y;
      }
      function X(y) {
        return X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(f) {
          return f.__proto__ || Object.getPrototypeOf(f);
        }, X(y);
      }
      function I(y, f, D) {
        return f in y ? Object.defineProperty(y, f, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : y[f] = D, y;
      }
      var $e = function(y) {
        (function(g, m) {
          if (typeof m != "function" && m !== null)
            throw new TypeError("Super expression must either be null or a function");
          g.prototype = Object.create(m && m.prototype, { constructor: { value: g, writable: !0, configurable: !0 } }), Object.defineProperty(g, "prototype", { writable: !1 }), m && x(g, m);
        })(ee, y);
        var f, D, T, se, V = (T = ee, se = function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }(), function() {
          var g, m = X(T);
          if (se) {
            var L = X(this).constructor;
            g = Reflect.construct(m, arguments, L);
          } else
            g = m.apply(this, arguments);
          return H(this, g);
        });
        function ee(g) {
          var m, L;
          return function(v, C) {
            if (!(v instanceof C))
              throw new TypeError("Cannot call a class as a function");
          }(this, ee), I(B(m = V.call(this, g)), "handlePreviousPage", function(v) {
            var C = m.state.selected;
            m.handleClick(v, null, C > 0 ? C - 1 : void 0, { isPrevious: !0 });
          }), I(B(m), "handleNextPage", function(v) {
            var C = m.state.selected, $ = m.props.pageCount;
            m.handleClick(v, null, C < $ - 1 ? C + 1 : void 0, { isNext: !0 });
          }), I(B(m), "handlePageSelected", function(v, C) {
            if (m.state.selected === v)
              return m.callActiveCallback(v), void m.handleClick(C, null, void 0, { isActive: !0 });
            m.handleClick(C, null, v);
          }), I(B(m), "handlePageChange", function(v) {
            m.state.selected !== v && (m.setState({ selected: v }), m.callCallback(v));
          }), I(B(m), "getEventListener", function(v) {
            return I({}, m.props.eventListener, v);
          }), I(B(m), "handleClick", function(v, C, $) {
            var Y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, U = Y.isPrevious, le = U !== void 0 && U, De = Y.isNext, Oe = De !== void 0 && De, Me = Y.isBreak, oe = Me !== void 0 && Me, he = Y.isActive, fe = he !== void 0 && he;
            v.preventDefault ? v.preventDefault() : v.returnValue = !1;
            var ge = m.state.selected, R = m.props.onClick, ie = $;
            if (R) {
              var ae = R({ index: C, selected: ge, nextSelectedPage: $, event: v, isPrevious: le, isNext: Oe, isBreak: oe, isActive: fe });
              if (ae === !1)
                return;
              Number.isInteger(ae) && (ie = ae);
            }
            ie !== void 0 && m.handlePageChange(ie);
          }), I(B(m), "handleBreakClick", function(v, C) {
            var $ = m.state.selected;
            m.handleClick(C, v, $ < v ? m.getForwardJump() : m.getBackwardJump(), { isBreak: !0 });
          }), I(B(m), "callCallback", function(v) {
            m.props.onPageChange !== void 0 && typeof m.props.onPageChange == "function" && m.props.onPageChange({ selected: v });
          }), I(B(m), "callActiveCallback", function(v) {
            m.props.onPageActive !== void 0 && typeof m.props.onPageActive == "function" && m.props.onPageActive({ selected: v });
          }), I(B(m), "getElementPageRel", function(v) {
            var C = m.state.selected, $ = m.props, Y = $.nextPageRel, U = $.prevPageRel, le = $.selectedPageRel;
            return C - 1 === v ? U : C === v ? le : C + 1 === v ? Y : void 0;
          }), I(B(m), "pagination", function() {
            var v = [], C = m.props, $ = C.pageRangeDisplayed, Y = C.pageCount, U = C.marginPagesDisplayed, le = C.breakLabel, De = C.breakClassName, Oe = C.breakLinkClassName, Me = C.breakAriaLabels, oe = m.state.selected;
            if (Y <= $)
              for (var he = 0; he < Y; he++)
                v.push(m.getPageElement(he));
            else {
              var fe = $ / 2, ge = $ - fe;
              oe > Y - $ / 2 ? fe = $ - (ge = Y - oe) : oe < $ / 2 && (ge = $ - (fe = oe));
              var R, ie, ae = function(pe) {
                return m.getPageElement(pe);
              }, q = [];
              for (R = 0; R < Y; R++) {
                var Re = R + 1;
                if (Re <= U)
                  q.push({ type: "page", index: R, display: ae(R) });
                else if (Re > Y - U)
                  q.push({ type: "page", index: R, display: ae(R) });
                else if (R >= oe - fe && R <= oe + (oe === 0 && $ > 1 ? ge - 1 : ge))
                  q.push({ type: "page", index: R, display: ae(R) });
                else if (le && q.length > 0 && q[q.length - 1].display !== ie && ($ > 0 || U > 0)) {
                  var Ve = R < oe ? Me.backward : Me.forward;
                  ie = l().createElement(z, { key: R, breakAriaLabel: Ve, breakLabel: le, breakClassName: De, breakLinkClassName: Oe, breakHandler: m.handleBreakClick.bind(null, R), getEventListener: m.getEventListener }), q.push({ type: "break", index: R, display: ie });
                }
              }
              q.forEach(function(pe, ye) {
                var Fe = pe;
                pe.type === "break" && q[ye - 1] && q[ye - 1].type === "page" && q[ye + 1] && q[ye + 1].type === "page" && q[ye + 1].index - q[ye - 1].index <= 2 && (Fe = { type: "page", index: pe.index, display: ae(pe.index) }), v.push(Fe.display);
              });
            }
            return v;
          }), g.initialPage !== void 0 && g.forcePage !== void 0 && console.warn("(react-paginate): Both initialPage (".concat(g.initialPage, ") and forcePage (").concat(g.forcePage, ") props are provided, which is discouraged.") + ` Use exclusively forcePage prop for a controlled component.
See https://reactjs.org/docs/forms.html#controlled-components`), L = g.initialPage ? g.initialPage : g.forcePage ? g.forcePage : 0, m.state = { selected: L }, m;
        }
        return f = ee, (D = [{ key: "componentDidMount", value: function() {
          var g = this.props, m = g.initialPage, L = g.disableInitialCallback, v = g.extraAriaContext, C = g.pageCount, $ = g.forcePage;
          m === void 0 || L || this.callCallback(m), v && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(C) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(C, "). Did you forget a Math.ceil()?")), m !== void 0 && m > C - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(m, " > ").concat(C - 1, ").")), $ !== void 0 && $ > C - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat($, " > ").concat(C - 1, ")."));
        } }, { key: "componentDidUpdate", value: function(g) {
          this.props.forcePage !== void 0 && this.props.forcePage !== g.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({ selected: this.props.forcePage })), Number.isInteger(g.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
        } }, { key: "getForwardJump", value: function() {
          var g = this.state.selected, m = this.props, L = m.pageCount, v = g + m.pageRangeDisplayed;
          return v >= L ? L - 1 : v;
        } }, { key: "getBackwardJump", value: function() {
          var g = this.state.selected - this.props.pageRangeDisplayed;
          return g < 0 ? 0 : g;
        } }, { key: "getElementHref", value: function(g) {
          var m = this.props, L = m.hrefBuilder, v = m.pageCount, C = m.hrefAllControls;
          if (L)
            return C || g >= 0 && g < v ? L(g + 1, v, this.state.selected) : void 0;
        } }, { key: "ariaLabelBuilder", value: function(g) {
          var m = g === this.state.selected;
          if (this.props.ariaLabelBuilder && g >= 0 && g < this.props.pageCount) {
            var L = this.props.ariaLabelBuilder(g + 1, m);
            return this.props.extraAriaContext && !m && (L = L + " " + this.props.extraAriaContext), L;
          }
        } }, { key: "getPageElement", value: function(g) {
          var m = this.state.selected, L = this.props, v = L.pageClassName, C = L.pageLinkClassName, $ = L.activeClassName, Y = L.activeLinkClassName, U = L.extraAriaContext, le = L.pageLabelBuilder;
          return l().createElement(P, { key: g, pageSelectedHandler: this.handlePageSelected.bind(null, g), selected: m === g, rel: this.getElementPageRel(g), pageClassName: v, pageLinkClassName: C, activeClassName: $, activeLinkClassName: Y, extraAriaContext: U, href: this.getElementHref(g), ariaLabel: this.ariaLabelBuilder(g), page: g + 1, pageLabelBuilder: le, getEventListener: this.getEventListener });
        } }, { key: "render", value: function() {
          var g = this.props.renderOnZeroPageCount;
          if (this.props.pageCount === 0 && g !== void 0)
            return g && g(this.props);
          var m = this.props, L = m.disabledClassName, v = m.disabledLinkClassName, C = m.pageCount, $ = m.className, Y = m.containerClassName, U = m.previousLabel, le = m.previousClassName, De = m.previousLinkClassName, Oe = m.previousAriaLabel, Me = m.prevRel, oe = m.nextLabel, he = m.nextClassName, fe = m.nextLinkClassName, ge = m.nextAriaLabel, R = m.nextRel, ie = this.state.selected, ae = ie === 0, q = ie === C - 1, Re = "".concat(S(le)).concat(ae ? " ".concat(S(L)) : ""), Ve = "".concat(S(he)).concat(q ? " ".concat(S(L)) : ""), pe = "".concat(S(De)).concat(ae ? " ".concat(S(v)) : ""), ye = "".concat(S(fe)).concat(q ? " ".concat(S(v)) : ""), Fe = ae ? "true" : "false", ma = q ? "true" : "false";
          return l().createElement("ul", { className: $ || Y, role: "navigation", "aria-label": "Pagination" }, l().createElement("li", { className: Re }, l().createElement("a", h({ className: pe, href: this.getElementHref(ie - 1), tabIndex: ae ? "-1" : "0", role: "button", onKeyPress: this.handlePreviousPage, "aria-disabled": Fe, "aria-label": Oe, rel: Me }, this.getEventListener(this.handlePreviousPage)), U)), this.pagination(), l().createElement("li", { className: Ve }, l().createElement("a", h({ className: ye, href: this.getElementHref(ie + 1), tabIndex: q ? "-1" : "0", role: "button", onKeyPress: this.handleNextPage, "aria-disabled": ma, "aria-label": ge, rel: R }, this.getEventListener(this.handleNextPage)), oe)));
        } }]) && k(f.prototype, D), Object.defineProperty(f, "prototype", { writable: !1 }), ee;
      }(s.Component);
      I($e, "propTypes", { pageCount: d().number.isRequired, pageRangeDisplayed: d().number, marginPagesDisplayed: d().number, previousLabel: d().node, previousAriaLabel: d().string, prevPageRel: d().string, prevRel: d().string, nextLabel: d().node, nextAriaLabel: d().string, nextPageRel: d().string, nextRel: d().string, breakLabel: d().oneOfType([d().string, d().node]), breakAriaLabels: d().shape({ forward: d().string, backward: d().string }), hrefBuilder: d().func, hrefAllControls: d().bool, onPageChange: d().func, onPageActive: d().func, onClick: d().func, initialPage: d().number, forcePage: d().number, disableInitialCallback: d().bool, containerClassName: d().string, className: d().string, pageClassName: d().string, pageLinkClassName: d().string, pageLabelBuilder: d().func, activeClassName: d().string, activeLinkClassName: d().string, previousClassName: d().string, nextClassName: d().string, previousLinkClassName: d().string, nextLinkClassName: d().string, disabledClassName: d().string, disabledLinkClassName: d().string, breakClassName: d().string, breakLinkClassName: d().string, extraAriaContext: d().string, ariaLabelBuilder: d().func, eventListener: d().string, renderOnZeroPageCount: d().func, selectedPageRel: d().string }), I($e, "defaultProps", { pageRangeDisplayed: 2, marginPagesDisplayed: 3, activeClassName: "selected", previousLabel: "Previous", previousClassName: "previous", previousAriaLabel: "Previous page", prevPageRel: "prev", prevRel: "prev", nextLabel: "Next", nextClassName: "next", nextAriaLabel: "Next page", nextPageRel: "next", nextRel: "next", breakLabel: "...", breakAriaLabels: { forward: "Jump forward", backward: "Jump backward" }, disabledClassName: "disabled", disableInitialCallback: !1, pageLabelBuilder: function(y) {
        return y;
      }, eventListener: "onClick", renderOnZeroPageCount: void 0, selectedPageRel: "canonical", hrefAllControls: !1 });
      const Xe = $e;
    })(), i;
  })());
})(Gt);
var Pn = Gt.exports;
const kn = /* @__PURE__ */ rn(Pn), Cn = "_Pagination_1oamq_64", En = "_paginationContainer_1oamq_68", xn = "_pageItem_1oamq_74", Dn = "_pageItemDisabled_1oamq_96", Tn = "_active_1oamq_118", Nn = "_breakEllipsis_1oamq_122", _n = "_previousIcon_1oamq_144", Sn = "_nextIcon_1oamq_148", Wn = "_labelWrapper_1oamq_152", $n = "_labelText_1oamq_158", Q = {
  Pagination: Cn,
  paginationContainer: En,
  pageItem: xn,
  pageItemDisabled: Dn,
  active: Tn,
  breakEllipsis: Nn,
  previousIcon: _n,
  nextIcon: Sn,
  labelWrapper: Wn,
  labelText: $n
}, On = ({
  forcePage: e,
  pageCount: a,
  onPageChange: t,
  hrefBuilder: n,
  previousLabel: r,
  nextLabel: o,
  ...i
}) => {
  const s = typeof e == "number" ? e + 1 : 1, l = s === 1, c = s === a, d = l ? Q.pageItemDisabled : Q.pageItem, p = l ? "grey" : "black", E = c ? Q.pageItemDisabled : Q.pageItem, P = c ? "grey" : "black";
  return /* @__PURE__ */ u("div", { className: Q.Pagination, "data-testid": "pagination", children: /* @__PURE__ */ u(
    kn,
    {
      forcePage: e,
      pageCount: a,
      onPageChange: t,
      containerClassName: Q.paginationContainer,
      pageClassName: Q.pageItem,
      previousClassName: d,
      nextClassName: E,
      activeClassName: Q.active,
      breakClassName: Q.breakEllipsis,
      previousLabel: /* @__PURE__ */ F("div", { className: Q.labelWrapper, "data-testid": "previous-page-button", children: [
        /* @__PURE__ */ u(rt, { className: Q.previousIcon, color: p, size: "xs" }),
        r ? /* @__PURE__ */ u("span", { className: Q.labelText, children: r }) : null
      ] }),
      nextLabel: /* @__PURE__ */ F("div", { className: Q.labelWrapper, "data-testid": "next-page-button", children: [
        o ? /* @__PURE__ */ u("span", { className: Q.labelText, children: o }) : null,
        /* @__PURE__ */ u(rt, { className: Q.nextIcon, color: P, size: "xs" })
      ] }),
      marginPagesDisplayed: 1,
      pageRangeDisplayed: 2,
      renderOnZeroPageCount: null,
      pageLinkClassName: "page-link",
      hrefBuilder: n,
      ...i
    }
  ) });
}, zn = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ln = (e, a, t) => {
  let n;
  const r = zn[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Ue(e) {
  return (a = {}) => {
    const t = a.width ? String(a.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const An = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, jn = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Hn = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rn = {
  date: Ue({
    formats: An,
    defaultWidth: "full"
  }),
  time: Ue({
    formats: jn,
    defaultWidth: "full"
  }),
  dateTime: Ue({
    formats: Hn,
    defaultWidth: "full"
  })
}, Fn = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, In = (e, a, t, n) => Fn[e];
function ze(e) {
  return (a, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let r;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      r = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      r = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(a) : a;
    return r[o];
  };
}
const Yn = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, qn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Bn = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Xn = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Vn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Jn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Un = (e, a) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Qn = {
  ordinalNumber: Un,
  era: ze({
    values: Yn,
    defaultWidth: "wide"
  }),
  quarter: ze({
    values: qn,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ze({
    values: Bn,
    defaultWidth: "wide"
  }),
  day: ze({
    values: Xn,
    defaultWidth: "wide"
  }),
  dayPeriod: ze({
    values: Vn,
    defaultWidth: "wide",
    formattingValues: Jn,
    defaultFormattingWidth: "wide"
  })
};
function Le(e) {
  return (a, t = {}) => {
    const n = t.width, r = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = a.match(r);
    if (!o)
      return null;
    const i = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? Gn(s, (p) => p.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      Zn(s, (p) => p.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(c)
    ) : c;
    const d = a.slice(i.length);
    return { value: c, rest: d };
  };
}
function Zn(e, a) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && a(e[t]))
      return t;
}
function Gn(e, a) {
  for (let t = 0; t < e.length; t++)
    if (a(e[t]))
      return t;
}
function Kn(e) {
  return (a, t = {}) => {
    const n = a.match(e.matchPattern);
    if (!n)
      return null;
    const r = n[0], o = a.match(e.parsePattern);
    if (!o)
      return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const s = a.slice(r.length);
    return { value: i, rest: s };
  };
}
const er = /^(\d+)(th|st|nd|rd)?/i, tr = /\d+/i, ar = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, nr = {
  any: [/^b/i, /^(a|c)/i]
}, rr = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, or = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ir = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, sr = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, dr = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, lr = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, cr = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, mr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ur = {
  ordinalNumber: Kn({
    matchPattern: er,
    parsePattern: tr,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Le({
    matchPatterns: ar,
    defaultMatchWidth: "wide",
    parsePatterns: nr,
    defaultParseWidth: "any"
  }),
  quarter: Le({
    matchPatterns: rr,
    defaultMatchWidth: "wide",
    parsePatterns: or,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Le({
    matchPatterns: ir,
    defaultMatchWidth: "wide",
    parsePatterns: sr,
    defaultParseWidth: "any"
  }),
  day: Le({
    matchPatterns: dr,
    defaultMatchWidth: "wide",
    parsePatterns: lr,
    defaultParseWidth: "any"
  }),
  dayPeriod: Le({
    matchPatterns: cr,
    defaultMatchWidth: "any",
    parsePatterns: mr,
    defaultParseWidth: "any"
  })
}, hr = {
  code: "en-US",
  formatDistance: Ln,
  formatLong: Rn,
  formatRelative: In,
  localize: Qn,
  match: ur,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let fr = {};
function He() {
  return fr;
}
const Kt = 6048e5, gr = 864e5, pt = Symbol.for("constructDateFrom");
function be(e, a) {
  return typeof e == "function" ? e(a) : e && typeof e == "object" && pt in e ? e[pt](a) : e instanceof Date ? new e.constructor(a) : new Date(a);
}
function de(e, a) {
  return be(a || e, e);
}
function yt(e) {
  const a = de(e), t = new Date(
    Date.UTC(
      a.getFullYear(),
      a.getMonth(),
      a.getDate(),
      a.getHours(),
      a.getMinutes(),
      a.getSeconds(),
      a.getMilliseconds()
    )
  );
  return t.setUTCFullYear(a.getFullYear()), +e - +t;
}
function pr(e, ...a) {
  const t = be.bind(
    null,
    e || a.find((n) => typeof n == "object")
  );
  return a.map(t);
}
function vt(e, a) {
  const t = de(e, a == null ? void 0 : a.in);
  return t.setHours(0, 0, 0, 0), t;
}
function yr(e, a, t) {
  const [n, r] = pr(
    t == null ? void 0 : t.in,
    e,
    a
  ), o = vt(n), i = vt(r), s = +o - yt(o), l = +i - yt(i);
  return Math.round((s - l) / gr);
}
function vr(e, a) {
  const t = de(e, a == null ? void 0 : a.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function br(e, a) {
  const t = de(e, a == null ? void 0 : a.in);
  return yr(t, vr(t)) + 1;
}
function je(e, a) {
  var s, l, c, d;
  const t = He(), n = (a == null ? void 0 : a.weekStartsOn) ?? ((l = (s = a == null ? void 0 : a.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((d = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, r = de(e, a == null ? void 0 : a.in), o = r.getDay(), i = (o < n ? 7 : 0) + o - n;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function Ye(e, a) {
  return je(e, { ...a, weekStartsOn: 1 });
}
function ea(e, a) {
  const t = de(e, a == null ? void 0 : a.in), n = t.getFullYear(), r = be(t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = Ye(r), i = be(t, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = Ye(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function Mr(e, a) {
  const t = ea(e, a), n = be((a == null ? void 0 : a.in) || e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Ye(n);
}
function wr(e, a) {
  const t = de(e, a == null ? void 0 : a.in), n = +Ye(t) - +Mr(t);
  return Math.round(n / Kt) + 1;
}
function ta(e, a) {
  var d, p, E, P;
  const t = de(e, a == null ? void 0 : a.in), n = t.getFullYear(), r = He(), o = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((p = (d = a == null ? void 0 : a.locale) == null ? void 0 : d.options) == null ? void 0 : p.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((P = (E = r.locale) == null ? void 0 : E.options) == null ? void 0 : P.firstWeekContainsDate) ?? 1, i = be((a == null ? void 0 : a.in) || e, 0);
  i.setFullYear(n + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = je(i, a), l = be((a == null ? void 0 : a.in) || e, 0);
  l.setFullYear(n, 0, o), l.setHours(0, 0, 0, 0);
  const c = je(l, a);
  return +t >= +s ? n + 1 : +t >= +c ? n : n - 1;
}
function Pr(e, a) {
  var s, l, c, d;
  const t = He(), n = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((l = (s = a == null ? void 0 : a.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((d = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = ta(e, a), o = be((a == null ? void 0 : a.in) || e, 0);
  return o.setFullYear(r, 0, n), o.setHours(0, 0, 0, 0), je(o, a);
}
function kr(e, a) {
  const t = de(e, a == null ? void 0 : a.in), n = +je(t, a) - +Pr(t, a);
  return Math.round(n / Kt) + 1;
}
function A(e, a) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(a, "0");
  return t + n;
}
const ve = {
  // Year
  y(e, a) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return A(a === "yy" ? n % 100 : n, a.length);
  },
  // Month
  M(e, a) {
    const t = e.getMonth();
    return a === "M" ? String(t + 1) : A(t + 1, 2);
  },
  // Day of the month
  d(e, a) {
    return A(e.getDate(), a.length);
  },
  // AM or PM
  a(e, a) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, a) {
    return A(e.getHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H(e, a) {
    return A(e.getHours(), a.length);
  },
  // Minute
  m(e, a) {
    return A(e.getMinutes(), a.length);
  },
  // Second
  s(e, a) {
    return A(e.getSeconds(), a.length);
  },
  // Fraction of second
  S(e, a) {
    const t = a.length, n = e.getMilliseconds(), r = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return A(r, a.length);
  }
}, Ne = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, bt = {
  // Era
  G: function(e, a, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, a, t) {
    if (a === "yo") {
      const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
      return t.ordinalNumber(r, { unit: "year" });
    }
    return ve.y(e, a);
  },
  // Local week-numbering year
  Y: function(e, a, t, n) {
    const r = ta(e, n), o = r > 0 ? r : 1 - r;
    if (a === "YY") {
      const i = o % 100;
      return A(i, 2);
    }
    return a === "Yo" ? t.ordinalNumber(o, { unit: "year" }) : A(o, a.length);
  },
  // ISO week-numbering year
  R: function(e, a) {
    const t = ea(e);
    return A(t, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, a) {
    const t = e.getFullYear();
    return A(t, a.length);
  },
  // Quarter
  Q: function(e, a, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "Q":
        return String(n);
      case "QQ":
        return A(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, a, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "q":
        return String(n);
      case "qq":
        return A(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, a, t) {
    const n = e.getMonth();
    switch (a) {
      case "M":
      case "MM":
        return ve.M(e, a);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, a, t) {
    const n = e.getMonth();
    switch (a) {
      case "L":
        return String(n + 1);
      case "LL":
        return A(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, a, t, n) {
    const r = kr(e, n);
    return a === "wo" ? t.ordinalNumber(r, { unit: "week" }) : A(r, a.length);
  },
  // ISO week of year
  I: function(e, a, t) {
    const n = wr(e);
    return a === "Io" ? t.ordinalNumber(n, { unit: "week" }) : A(n, a.length);
  },
  // Day of the month
  d: function(e, a, t) {
    return a === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : ve.d(e, a);
  },
  // Day of year
  D: function(e, a, t) {
    const n = br(e);
    return a === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : A(n, a.length);
  },
  // Day of week
  E: function(e, a, t) {
    const n = e.getDay();
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, a, t, n) {
    const r = e.getDay(), o = (r - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "e":
        return String(o);
      case "ee":
        return A(o, 2);
      case "eo":
        return t.ordinalNumber(o, { unit: "day" });
      case "eee":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, a, t, n) {
    const r = e.getDay(), o = (r - n.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "c":
        return String(o);
      case "cc":
        return A(o, a.length);
      case "co":
        return t.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return t.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, a, t) {
    const n = e.getDay(), r = n === 0 ? 7 : n;
    switch (a) {
      case "i":
        return String(r);
      case "ii":
        return A(r, a.length);
      case "io":
        return t.ordinalNumber(r, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, a, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, a, t) {
    const n = e.getHours();
    let r;
    switch (n === 12 ? r = Ne.noon : n === 0 ? r = Ne.midnight : r = n / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, a, t) {
    const n = e.getHours();
    let r;
    switch (n >= 17 ? r = Ne.evening : n >= 12 ? r = Ne.afternoon : n >= 4 ? r = Ne.morning : r = Ne.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, a, t) {
    if (a === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return ve.h(e, a);
  },
  // Hour [0-23]
  H: function(e, a, t) {
    return a === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : ve.H(e, a);
  },
  // Hour [0-11]
  K: function(e, a, t) {
    const n = e.getHours() % 12;
    return a === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : A(n, a.length);
  },
  // Hour [1-24]
  k: function(e, a, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), a === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : A(n, a.length);
  },
  // Minute
  m: function(e, a, t) {
    return a === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ve.m(e, a);
  },
  // Second
  s: function(e, a, t) {
    return a === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : ve.s(e, a);
  },
  // Fraction of second
  S: function(e, a) {
    return ve.S(e, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (a) {
      case "X":
        return wt(n);
      case "XXXX":
      case "XX":
        return we(n);
      case "XXXXX":
      case "XXX":
      default:
        return we(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      case "x":
        return wt(n);
      case "xxxx":
      case "xx":
        return we(n);
      case "xxxxx":
      case "xxx":
      default:
        return we(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Mt(n, ":");
      case "OOOO":
      default:
        return "GMT" + we(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, t) {
    const n = e.getTimezoneOffset();
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Mt(n, ":");
      case "zzzz":
      default:
        return "GMT" + we(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, a, t) {
    const n = Math.trunc(+e / 1e3);
    return A(n, a.length);
  },
  // Milliseconds timestamp
  T: function(e, a, t) {
    return A(+e, a.length);
  }
};
function Mt(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? t + String(r) : t + String(r) + a + A(o, 2);
}
function wt(e, a) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + A(Math.abs(e) / 60, 2) : we(e, a);
}
function we(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), r = A(Math.trunc(n / 60), 2), o = A(n % 60, 2);
  return t + r + a + o;
}
const Pt = (e, a) => {
  switch (e) {
    case "P":
      return a.date({ width: "short" });
    case "PP":
      return a.date({ width: "medium" });
    case "PPP":
      return a.date({ width: "long" });
    case "PPPP":
    default:
      return a.date({ width: "full" });
  }
}, aa = (e, a) => {
  switch (e) {
    case "p":
      return a.time({ width: "short" });
    case "pp":
      return a.time({ width: "medium" });
    case "ppp":
      return a.time({ width: "long" });
    case "pppp":
    default:
      return a.time({ width: "full" });
  }
}, Cr = (e, a) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], r = t[2];
  if (!r)
    return Pt(e, a);
  let o;
  switch (n) {
    case "P":
      o = a.dateTime({ width: "short" });
      break;
    case "PP":
      o = a.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = a.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = a.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Pt(n, a)).replace("{{time}}", aa(r, a));
}, Er = {
  p: aa,
  P: Cr
}, xr = /^D+$/, Dr = /^Y+$/, Tr = ["D", "DD", "YY", "YYYY"];
function Nr(e) {
  return xr.test(e);
}
function _r(e) {
  return Dr.test(e);
}
function Sr(e, a, t) {
  const n = Wr(e, a, t);
  if (console.warn(n), Tr.includes(e))
    throw new RangeError(n);
}
function Wr(e, a, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${a}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function $r(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Or(e) {
  return !(!$r(e) && typeof e != "number" || isNaN(+de(e)));
}
const zr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Lr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ar = /^'([^]*?)'?$/, jr = /''/g, Hr = /[a-zA-Z]/;
function Rr(e, a, t) {
  var d, p, E, P, N, O, z, S;
  const n = He(), r = (t == null ? void 0 : t.locale) ?? n.locale ?? hr, o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((P = (E = n.locale) == null ? void 0 : E.options) == null ? void 0 : P.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((O = (N = t == null ? void 0 : t.locale) == null ? void 0 : N.options) == null ? void 0 : O.weekStartsOn) ?? n.weekStartsOn ?? ((S = (z = n.locale) == null ? void 0 : z.options) == null ? void 0 : S.weekStartsOn) ?? 0, s = de(e, t == null ? void 0 : t.in);
  if (!Or(s))
    throw new RangeError("Invalid time value");
  let l = a.match(Lr).map((W) => {
    const h = W[0];
    if (h === "p" || h === "P") {
      const k = Er[h];
      return k(W, r.formatLong);
    }
    return W;
  }).join("").match(zr).map((W) => {
    if (W === "''")
      return { isToken: !1, value: "'" };
    const h = W[0];
    if (h === "'")
      return { isToken: !1, value: Fr(W) };
    if (bt[h])
      return { isToken: !0, value: W };
    if (h.match(Hr))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + h + "`"
      );
    return { isToken: !1, value: W };
  });
  r.localize.preprocessor && (l = r.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: r
  };
  return l.map((W) => {
    if (!W.isToken)
      return W.value;
    const h = W.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && _r(h) || !(t != null && t.useAdditionalDayOfYearTokens) && Nr(h)) && Sr(h, a, String(e));
    const k = bt[h[0]];
    return k(s, h, r.localize, c);
  }).join("");
}
function Fr(e) {
  const a = e.match(Ar);
  return a ? a[1].replace(jr, "'") : e;
}
function Ir() {
  return Object.assign({}, He());
}
function kt(e, a, t) {
  const n = Ir(), r = Br(e, t.timeZone, t.locale ?? n.locale);
  return "formatToParts" in r ? Yr(r, a) : qr(r, a);
}
function Yr(e, a) {
  const t = e.formatToParts(a);
  for (let n = t.length - 1; n >= 0; --n)
    if (t[n].type === "timeZoneName")
      return t[n].value;
}
function qr(e, a) {
  const t = e.format(a).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(t);
  return n ? n[0].substr(1) : "";
}
function Br(e, a, t) {
  return new Intl.DateTimeFormat(t ? [t.code, "en-US"] : void 0, {
    timeZone: a,
    timeZoneName: e
  });
}
function Xr(e, a) {
  const t = Zr(a);
  return "formatToParts" in t ? Jr(t, e) : Ur(t, e);
}
const Vr = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Jr(e, a) {
  try {
    const t = e.formatToParts(a), n = [];
    for (let r = 0; r < t.length; r++) {
      const o = Vr[t[r].type];
      o !== void 0 && (n[o] = parseInt(t[r].value, 10));
    }
    return n;
  } catch (t) {
    if (t instanceof RangeError)
      return [NaN];
    throw t;
  }
}
function Ur(e, a) {
  const t = e.format(a), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(t);
  return [
    parseInt(n[3], 10),
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[4], 10),
    parseInt(n[5], 10),
    parseInt(n[6], 10)
  ];
}
const Qe = {}, Ct = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Qr = Ct === "06/25/2014, 00:00:00" || Ct === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function Zr(e) {
  return Qe[e] || (Qe[e] = Qr ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), Qe[e];
}
function na(e, a, t, n, r, o, i) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, a, t), s.setUTCHours(n, r, o, i), s;
}
const Et = 36e5, Gr = 6e4, Ze = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function dt(e, a, t) {
  if (!e)
    return 0;
  let n = Ze.timezoneZ.exec(e);
  if (n)
    return 0;
  let r, o;
  if (n = Ze.timezoneHH.exec(e), n)
    return r = parseInt(n[1], 10), xt(r) ? -(r * Et) : NaN;
  if (n = Ze.timezoneHHMM.exec(e), n) {
    r = parseInt(n[2], 10);
    const i = parseInt(n[3], 10);
    return xt(r, i) ? (o = Math.abs(r) * Et + i * Gr, n[1] === "+" ? -o : o) : NaN;
  }
  if (to(e)) {
    a = new Date(a || Date.now());
    const i = t ? a : Kr(a), s = ot(i, e);
    return -(t ? s : eo(a, s, e));
  }
  return NaN;
}
function Kr(e) {
  return na(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function ot(e, a) {
  const t = Xr(e, a), n = na(t[0], t[1] - 1, t[2], t[3] % 24, t[4], t[5], 0).getTime();
  let r = e.getTime();
  const o = r % 1e3;
  return r -= o >= 0 ? o : 1e3 + o, n - r;
}
function eo(e, a, t) {
  let r = e.getTime() - a;
  const o = ot(new Date(r), t);
  if (a === o)
    return a;
  r -= o - a;
  const i = ot(new Date(r), t);
  return o === i ? o : Math.max(o, i);
}
function xt(e, a) {
  return -23 <= e && e <= 23 && (a == null || 0 <= a && a <= 59);
}
const Dt = {};
function to(e) {
  if (Dt[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Dt[e] = !0, !0;
  } catch {
    return !1;
  }
}
const ao = 60 * 1e3, no = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, t) {
    const n = Ge(t.timeZone, e);
    if (n === 0)
      return "Z";
    switch (a) {
      case "X":
        return Tt(n);
      case "XXXX":
      case "XX":
        return _e(n);
      case "XXXXX":
      case "XXX":
      default:
        return _e(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, t) {
    const n = Ge(t.timeZone, e);
    switch (a) {
      case "x":
        return Tt(n);
      case "xxxx":
      case "xx":
        return _e(n);
      case "xxxxx":
      case "xxx":
      default:
        return _e(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, t) {
    const n = Ge(t.timeZone, e);
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ro(n, ":");
      case "OOOO":
      default:
        return "GMT" + _e(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, t) {
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return kt("short", e, t);
      case "zzzz":
      default:
        return kt("long", e, t);
    }
  }
};
function Ge(e, a) {
  const t = e ? dt(e, a, !0) / ao : (a == null ? void 0 : a.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(t))
    throw new RangeError("Invalid time zone specified: " + e);
  return t;
}
function qe(e, a) {
  const t = e < 0 ? "-" : "";
  let n = Math.abs(e).toString();
  for (; n.length < a; )
    n = "0" + n;
  return t + n;
}
function _e(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), r = qe(Math.floor(n / 60), 2), o = qe(Math.floor(n % 60), 2);
  return t + r + a + o;
}
function Tt(e, a) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + qe(Math.abs(e) / 60, 2) : _e(e, a);
}
function ro(e, a = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 60), o = n % 60;
  return o === 0 ? t + String(r) : t + String(r) + a + qe(o, 2);
}
function Nt(e) {
  const a = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return a.setUTCFullYear(e.getFullYear()), +e - +a;
}
const oo = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Ke = 36e5, _t = 6e4, io = 2, Z = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: oo
};
function ra(e, a = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = a.additionalDigits == null ? io : Number(a.additionalDigits);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const n = so(e), { year: r, restDateString: o } = lo(n.date, t), i = co(o, r);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const s = i.getTime();
    let l = 0, c;
    if (n.time && (l = mo(n.time), l === null || isNaN(l)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || a.timeZone) {
      if (c = dt(n.timeZone || a.timeZone, new Date(s + l)), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
    } else
      c = Nt(new Date(s + l)), c = Nt(new Date(s + l + c));
    return new Date(s + l + c);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function so(e) {
  const a = {};
  let t = Z.dateTimePattern.exec(e), n;
  if (t ? (a.date = t[1], n = t[3]) : (t = Z.datePattern.exec(e), t ? (a.date = t[1], n = t[2]) : (a.date = null, n = e)), n) {
    const r = Z.timeZone.exec(n);
    r ? (a.time = n.replace(r[1], ""), a.timeZone = r[1].trim()) : a.time = n;
  }
  return a;
}
function lo(e, a) {
  if (e) {
    const t = Z.YYY[a], n = Z.YYYYY[a];
    let r = Z.YYYY.exec(e) || n.exec(e);
    if (r) {
      const o = r[1];
      return {
        year: parseInt(o, 10),
        restDateString: e.slice(o.length)
      };
    }
    if (r = Z.YY.exec(e) || t.exec(e), r) {
      const o = r[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: e.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function co(e, a) {
  if (a === null)
    return null;
  let t, n, r;
  if (!e || !e.length)
    return t = /* @__PURE__ */ new Date(0), t.setUTCFullYear(a), t;
  let o = Z.MM.exec(e);
  if (o)
    return t = /* @__PURE__ */ new Date(0), n = parseInt(o[1], 10) - 1, Wt(a, n) ? (t.setUTCFullYear(a, n), t) : /* @__PURE__ */ new Date(NaN);
  if (o = Z.DDD.exec(e), o) {
    t = /* @__PURE__ */ new Date(0);
    const i = parseInt(o[1], 10);
    return fo(a, i) ? (t.setUTCFullYear(a, 0, i), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Z.MMDD.exec(e), o) {
    t = /* @__PURE__ */ new Date(0), n = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10);
    return Wt(a, n, i) ? (t.setUTCFullYear(a, n, i), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Z.Www.exec(e), o)
    return r = parseInt(o[1], 10) - 1, $t(r) ? St(a, r) : /* @__PURE__ */ new Date(NaN);
  if (o = Z.WwwD.exec(e), o) {
    r = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10) - 1;
    return $t(r, i) ? St(a, r, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function mo(e) {
  let a, t, n = Z.HH.exec(e);
  if (n)
    return a = parseFloat(n[1].replace(",", ".")), et(a) ? a % 24 * Ke : NaN;
  if (n = Z.HHMM.exec(e), n)
    return a = parseInt(n[1], 10), t = parseFloat(n[2].replace(",", ".")), et(a, t) ? a % 24 * Ke + t * _t : NaN;
  if (n = Z.HHMMSS.exec(e), n) {
    a = parseInt(n[1], 10), t = parseInt(n[2], 10);
    const r = parseFloat(n[3].replace(",", "."));
    return et(a, t, r) ? a % 24 * Ke + t * _t + r * 1e3 : NaN;
  }
  return null;
}
function St(e, a, t) {
  a = a || 0, t = t || 0;
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const r = n.getUTCDay() || 7, o = a * 7 + t + 1 - r;
  return n.setUTCDate(n.getUTCDate() + o), n;
}
const uo = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ho = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function oa(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Wt(e, a, t) {
  if (a < 0 || a > 11)
    return !1;
  if (t != null) {
    if (t < 1)
      return !1;
    const n = oa(e);
    if (n && t > ho[a] || !n && t > uo[a])
      return !1;
  }
  return !0;
}
function fo(e, a) {
  if (a < 1)
    return !1;
  const t = oa(e);
  return !(t && a > 366 || !t && a > 365);
}
function $t(e, a) {
  return !(e < 0 || e > 52 || a != null && (a < 0 || a > 6));
}
function et(e, a, t) {
  return !(e < 0 || e >= 25 || a != null && (a < 0 || a >= 60) || t != null && (t < 0 || t >= 60));
}
const go = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function po(e, a, t = {}) {
  a = String(a);
  const n = a.match(go);
  if (n) {
    const r = ra(t.originalDate || e, t);
    a = n.reduce(function(o, i) {
      if (i[0] === "'")
        return o;
      const s = o.indexOf(i), l = o[s - 1] === "'", c = o.replace(i, "'" + no[i[0]](r, i, t) + "'");
      return l ? c.substring(0, s - 1) + c.substring(s + 1) : c;
    }, a);
  }
  return Rr(e, a, t);
}
function yo(e, a, t) {
  e = ra(e, t);
  const n = dt(a, e, !0), r = new Date(e.getTime() - n), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), o.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), o;
}
function vo(e, a, t, n) {
  return n = {
    ...n,
    timeZone: a,
    originalDate: e
  }, po(yo(e, a, { timeZone: n.timeZone }), t, n);
}
const bo = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, Mo = (e, a, t) => {
  let n;
  const r = bo[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", String(a)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "om " + n : n + " siden" : n;
};
function w(e) {
  return (a = {}) => {
    const t = a.width ? String(a.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const wo = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, Po = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ko = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Co = {
  date: w({
    formats: wo,
    defaultWidth: "full"
  }),
  time: w({
    formats: Po,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: ko,
    defaultWidth: "full"
  })
}, Eo = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, xo = (e, a, t, n) => Eo[e];
function b(e) {
  return (a, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let r;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      r = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      r = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(a) : a;
    return r[o];
  };
}
const Do = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, To = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, No = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, _o = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, So = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, Wo = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, $o = (e, a) => Number(e) + ".", Oo = {
  ordinalNumber: $o,
  era: b({
    values: Do,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: To,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: No,
    defaultWidth: "wide"
  }),
  day: b({
    values: _o,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: So,
    defaultWidth: "wide",
    formattingValues: Wo,
    defaultFormattingWidth: "wide"
  })
};
function M(e) {
  return (a, t = {}) => {
    const n = t.width, r = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = a.match(r);
    if (!o)
      return null;
    const i = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? Lo(s, (p) => p.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      zo(s, (p) => p.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(c)
    ) : c;
    const d = a.slice(i.length);
    return { value: c, rest: d };
  };
}
function zo(e, a) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && a(e[t]))
      return t;
}
function Lo(e, a) {
  for (let t = 0; t < e.length; t++)
    if (a(e[t]))
      return t;
}
function ce(e) {
  return (a, t = {}) => {
    const n = a.match(e.matchPattern);
    if (!n)
      return null;
    const r = n[0], o = a.match(e.parsePattern);
    if (!o)
      return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const s = a.slice(r.length);
    return { value: i, rest: s };
  };
}
const Ao = /^(\d+)(\.)?/i, jo = /\d+/i, Ho = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Ro = {
  any: [/^f/i, /^(v|e)/i]
}, Fo = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Io = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yo = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, qo = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Bo = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Xo = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Vo = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, Jo = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, Uo = {
  ordinalNumber: ce({
    matchPattern: Ao,
    parsePattern: jo,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: Ho,
    defaultMatchWidth: "wide",
    parsePatterns: Ro,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Fo,
    defaultMatchWidth: "wide",
    parsePatterns: Io,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Yo,
    defaultMatchWidth: "wide",
    parsePatterns: qo,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Bo,
    defaultMatchWidth: "wide",
    parsePatterns: Xo,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: Vo,
    defaultMatchWidth: "any",
    parsePatterns: Jo,
    defaultParseWidth: "any"
  })
}, Qo = {
  code: "da",
  formatDistance: Mo,
  formatLong: Co,
  formatRelative: xo,
  localize: Oo,
  match: Uo,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ot = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Zo = (e, a, t) => {
  let n;
  const r = t != null && t.addSuffix ? Ot[e].withPreposition : Ot[e].standalone;
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", String(a)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : "vor " + n : n;
}, Go = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Ko = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ei = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ti = {
  date: w({
    formats: Go,
    defaultWidth: "full"
  }),
  time: w({
    formats: Ko,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: ei,
    defaultWidth: "full"
  })
}, ai = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, ni = (e, a, t, n) => ai[e], ri = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, oi = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, it = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, ii = {
  narrow: it.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: it.wide
}, si = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, di = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, li = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, ci = (e) => Number(e) + ".", mi = {
  ordinalNumber: ci,
  era: b({
    values: ri,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: oi,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: it,
    formattingValues: ii,
    defaultWidth: "wide"
  }),
  day: b({
    values: si,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: di,
    defaultWidth: "wide",
    formattingValues: li,
    defaultFormattingWidth: "wide"
  })
}, ui = /^(\d+)(\.)?/i, hi = /\d+/i, fi = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, gi = {
  any: [/^v/i, /^n/i]
}, pi = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, yi = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vi = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, bi = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Mi = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, wi = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Pi = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, ki = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, Ci = {
  ordinalNumber: ce({
    matchPattern: ui,
    parsePattern: hi,
    valueCallback: (e) => parseInt(e)
  }),
  era: M({
    matchPatterns: fi,
    defaultMatchWidth: "wide",
    parsePatterns: gi,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: pi,
    defaultMatchWidth: "wide",
    parsePatterns: yi,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: vi,
    defaultMatchWidth: "wide",
    parsePatterns: bi,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Mi,
    defaultMatchWidth: "wide",
    parsePatterns: wi,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: Pi,
    defaultMatchWidth: "wide",
    parsePatterns: ki,
    defaultParseWidth: "any"
  })
}, Ei = {
  code: "de",
  formatDistance: Zo,
  formatLong: ti,
  formatRelative: ni,
  localize: mi,
  match: Ci,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, xi = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, We = (e, a, t) => {
  let n;
  const r = xi[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
}, Di = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Ti = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ni = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _i = {
  date: w({
    formats: Di,
    defaultWidth: "full"
  }),
  time: w({
    formats: Ti,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Ni,
    defaultWidth: "full"
  })
}, Si = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ce = (e, a, t, n) => Si[e], Wi = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, $i = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Oi = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, zi = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Li = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ai = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ji = (e, a) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Ee = {
  ordinalNumber: ji,
  era: b({
    values: Wi,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: $i,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: Oi,
    defaultWidth: "wide"
  }),
  day: b({
    values: zi,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: Li,
    defaultWidth: "wide",
    formattingValues: Ai,
    defaultFormattingWidth: "wide"
  })
}, Hi = /^(\d+)(th|st|nd|rd)?/i, Ri = /\d+/i, Fi = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ii = {
  any: [/^b/i, /^(a|c)/i]
}, Yi = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, qi = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bi = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Xi = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Vi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ji = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ui = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Qi = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, xe = {
  ordinalNumber: ce({
    matchPattern: Hi,
    parsePattern: Ri,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: Fi,
    defaultMatchWidth: "wide",
    parsePatterns: Ii,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Yi,
    defaultMatchWidth: "wide",
    parsePatterns: qi,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Bi,
    defaultMatchWidth: "wide",
    parsePatterns: Xi,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Vi,
    defaultMatchWidth: "wide",
    parsePatterns: Ji,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: Ui,
    defaultMatchWidth: "any",
    parsePatterns: Qi,
    defaultParseWidth: "any"
  })
}, Zi = {
  code: "en-AU",
  formatDistance: We,
  formatLong: _i,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Gi = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, Ki = (e, a, t) => {
  let n;
  const r = Gi[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
}, es = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, ts = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, as = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ns = {
  date: w({
    formats: es,
    defaultWidth: "full"
  }),
  time: w({
    formats: ts,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: as,
    defaultWidth: "full"
  })
}, rs = {
  code: "en-CA",
  formatDistance: Ki,
  formatLong: ns,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, os = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, is = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ss = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ds = {
  date: w({
    formats: os,
    defaultWidth: "full"
  }),
  time: w({
    formats: is,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: ss,
    defaultWidth: "full"
  })
}, ls = {
  code: "en-GB",
  formatDistance: We,
  formatLong: ds,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, cs = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, ms = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, us = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hs = {
  date: w({
    formats: cs,
    defaultWidth: "full"
  }),
  time: w({
    formats: ms,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: us,
    defaultWidth: "full"
  })
}, fs = {
  code: "en-IN",
  formatDistance: We,
  formatLong: hs,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
}, gs = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, ps = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ys = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vs = {
  date: w({
    formats: gs,
    defaultWidth: "full"
  }),
  time: w({
    formats: ps,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: ys,
    defaultWidth: "full"
  })
}, bs = {
  code: "en-NZ",
  formatDistance: We,
  formatLong: vs,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ms = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ws = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ps = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ks = {
  date: w({
    formats: Ms,
    defaultWidth: "full"
  }),
  time: w({
    formats: ws,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Ps,
    defaultWidth: "full"
  })
}, Cs = {
  code: "en-US",
  formatDistance: We,
  formatLong: ks,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Es = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, xs = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ds = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ts = {
  date: w({
    formats: Es,
    defaultWidth: "full"
  }),
  time: w({
    formats: xs,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Ds,
    defaultWidth: "full"
  })
}, Ns = {
  code: "en-ZA",
  formatDistance: We,
  formatLong: Ts,
  formatRelative: Ce,
  localize: Ee,
  match: xe,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
}, _s = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, Ss = (e, a, t) => {
  let n;
  const r = _s[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "en " + n : "hace " + n : n;
}, Ws = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, $s = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Os = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zs = {
  date: w({
    formats: Ws,
    defaultWidth: "full"
  }),
  time: w({
    formats: $s,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Os,
    defaultWidth: "full"
  })
}, Ls = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, As = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, js = (e, a, t, n) => a.getHours() !== 1 ? As[e] : Ls[e], Hs = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, Rs = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Fs = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, Is = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Ys = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, qs = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Bs = (e, a) => Number(e) + "º", Xs = {
  ordinalNumber: Bs,
  era: b({
    values: Hs,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: Rs,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: b({
    values: Fs,
    defaultWidth: "wide"
  }),
  day: b({
    values: Is,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: Ys,
    defaultWidth: "wide",
    formattingValues: qs,
    defaultFormattingWidth: "wide"
  })
}, Vs = /^(\d+)(º)?/i, Js = /\d+/i, Us = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Qs = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Zs = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Gs = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ks = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, ed = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, td = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, ad = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, nd = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, rd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, od = {
  ordinalNumber: ce({
    matchPattern: Vs,
    parsePattern: Js,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: M({
    matchPatterns: Us,
    defaultMatchWidth: "wide",
    parsePatterns: Qs,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Zs,
    defaultMatchWidth: "wide",
    parsePatterns: Gs,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Ks,
    defaultMatchWidth: "wide",
    parsePatterns: ed,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: td,
    defaultMatchWidth: "wide",
    parsePatterns: ad,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: nd,
    defaultMatchWidth: "any",
    parsePatterns: rd,
    defaultParseWidth: "any"
  })
}, id = {
  code: "es",
  formatDistance: Ss,
  formatLong: zs,
  formatRelative: js,
  localize: Xs,
  match: od,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, sd = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, dd = (e, a, t) => {
  let n;
  const r = sd[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", String(a)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "dans " + n : "il y a " + n : n;
}, ld = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, cd = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, md = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ud = {
  date: w({
    formats: ld,
    defaultWidth: "full"
  }),
  time: w({
    formats: cd,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: md,
    defaultWidth: "full"
  })
}, hd = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, fd = (e, a, t, n) => hd[e], gd = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, pd = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, yd = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, vd = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, bd = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, Md = (e, a) => {
  const t = Number(e), n = a == null ? void 0 : a.unit;
  if (t === 0)
    return "0";
  const r = ["year", "week", "hour", "minute", "second"];
  let o;
  return t === 1 ? o = n && r.includes(n) ? "ère" : "er" : o = "ème", t + o;
}, wd = ["MMM", "MMMM"], Pd = {
  preprocessor: (e, a) => e.getDate() === 1 || !a.some(
    (n) => n.isToken && wd.includes(n.value)
  ) ? a : a.map(
    (n) => n.isToken && n.value === "do" ? { isToken: !0, value: "d" } : n
  ),
  ordinalNumber: Md,
  era: b({
    values: gd,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: pd,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: yd,
    defaultWidth: "wide"
  }),
  day: b({
    values: vd,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: bd,
    defaultWidth: "wide"
  })
}, kd = /^(\d+)(ième|ère|ème|er|e)?/i, Cd = /\d+/i, Ed = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, xd = {
  any: [/^av/i, /^ap/i]
}, Dd = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Td = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nd = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, _d = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Sd = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, Wd = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, $d = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, Od = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, zd = {
  ordinalNumber: ce({
    matchPattern: kd,
    parsePattern: Cd,
    valueCallback: (e) => parseInt(e)
  }),
  era: M({
    matchPatterns: Ed,
    defaultMatchWidth: "wide",
    parsePatterns: xd,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Dd,
    defaultMatchWidth: "wide",
    parsePatterns: Td,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Nd,
    defaultMatchWidth: "wide",
    parsePatterns: _d,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Sd,
    defaultMatchWidth: "wide",
    parsePatterns: Wd,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: $d,
    defaultMatchWidth: "any",
    parsePatterns: Od,
    defaultParseWidth: "any"
  })
}, Ld = {
  code: "fr",
  formatDistance: dd,
  formatLong: ud,
  formatRelative: fd,
  localize: Pd,
  match: zd,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ad = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, jd = (e, a, t) => {
  let n;
  const r = Ad[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "tra " + n : n + " fa" : n;
}, Hd = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Rd = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Fd = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Id = {
  date: w({
    formats: Hd,
    defaultWidth: "full"
  }),
  time: w({
    formats: Rd,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Fd,
    defaultWidth: "full"
  })
};
function Yd(e) {
  const a = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && a === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || a === "[object Number]" || typeof e == "string" || a === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
let qd = {};
function Bd() {
  return qd;
}
function zt(e, a) {
  var s, l, c, d;
  const t = Bd(), n = (a == null ? void 0 : a.weekStartsOn) ?? ((l = (s = a == null ? void 0 : a.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((d = (c = t.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, r = Yd(e), o = r.getDay(), i = (o < n ? 7 : 0) + o - n;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function Lt(e, a, t) {
  const n = zt(e, t), r = zt(a, t);
  return +n == +r;
}
const lt = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function Xd(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + lt[e] + " scorso alle' p";
  }
}
function At(e) {
  return "'" + lt[e] + " alle' p";
}
function Vd(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + lt[e] + " prossimo alle' p";
  }
}
const Jd = {
  lastWeek: (e, a, t) => {
    const n = e.getDay();
    return Lt(e, a, t) ? At(n) : Xd(n);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (e, a, t) => {
    const n = e.getDay();
    return Lt(e, a, t) ? At(n) : Vd(n);
  },
  other: "P"
}, Ud = (e, a, t, n) => {
  const r = Jd[e];
  return typeof r == "function" ? r(a, t, n) : r;
}, Qd = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, Zd = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Gd = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, Kd = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, el = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, tl = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, al = (e, a) => {
  const t = Number(e);
  return String(t);
}, nl = {
  ordinalNumber: al,
  era: b({
    values: Qd,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: Zd,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: Gd,
    defaultWidth: "wide"
  }),
  day: b({
    values: Kd,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: el,
    defaultWidth: "wide",
    formattingValues: tl,
    defaultFormattingWidth: "wide"
  })
}, rl = /^(\d+)(º)?/i, ol = /\d+/i, il = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, sl = {
  any: [/^a/i, /^(d|e)/i]
}, dl = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, ll = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cl = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, ml = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ul = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, hl = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, fl = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, gl = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, pl = {
  ordinalNumber: ce({
    matchPattern: rl,
    parsePattern: ol,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: il,
    defaultMatchWidth: "wide",
    parsePatterns: sl,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: dl,
    defaultMatchWidth: "wide",
    parsePatterns: ll,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: cl,
    defaultMatchWidth: "wide",
    parsePatterns: ml,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: ul,
    defaultMatchWidth: "wide",
    parsePatterns: hl,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: fl,
    defaultMatchWidth: "any",
    parsePatterns: gl,
    defaultParseWidth: "any"
  })
}, yl = {
  code: "it",
  formatDistance: jd,
  formatLong: Id,
  formatRelative: Ud,
  localize: nl,
  match: pl,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, vl = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, bl = (e, a, t) => {
  let n;
  const r = vl[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", String(a)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "over " + n : n + " geleden" : n;
}, Ml = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, wl = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Pl = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, kl = {
  date: w({
    formats: Ml,
    defaultWidth: "full"
  }),
  time: w({
    formats: wl,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Pl,
    defaultWidth: "full"
  })
}, Cl = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, El = (e, a, t, n) => Cl[e], xl = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Dl = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Tl = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Nl = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, _l = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Sl = (e, a) => Number(e) + "e", Wl = {
  ordinalNumber: Sl,
  era: b({
    values: xl,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: Dl,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: Tl,
    defaultWidth: "wide"
  }),
  day: b({
    values: Nl,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: _l,
    defaultWidth: "wide"
  })
}, $l = /^(\d+)e?/i, Ol = /\d+/i, zl = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, Ll = {
  any: [/^v/, /^n/]
}, Al = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, jl = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Hl = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Rl = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, Fl = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Il = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Yl = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, ql = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, Bl = {
  ordinalNumber: ce({
    matchPattern: $l,
    parsePattern: Ol,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: zl,
    defaultMatchWidth: "wide",
    parsePatterns: Ll,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Al,
    defaultMatchWidth: "wide",
    parsePatterns: jl,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Hl,
    defaultMatchWidth: "wide",
    parsePatterns: Rl,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Fl,
    defaultMatchWidth: "wide",
    parsePatterns: Il,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: Yl,
    defaultMatchWidth: "any",
    parsePatterns: ql,
    defaultParseWidth: "any"
  })
}, Xl = {
  code: "nl",
  formatDistance: bl,
  formatLong: kl,
  formatRelative: El,
  localize: Wl,
  match: Bl,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Vl = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Jl = (e, a, t) => {
  let n;
  const r = Vl[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", String(a)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "daqui a " + n : "há " + n : n;
}, Ul = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, Ql = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Zl = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Gl = {
  date: w({
    formats: Ul,
    defaultWidth: "full"
  }),
  time: w({
    formats: Ql,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Zl,
    defaultWidth: "full"
  })
}, Kl = {
  lastWeek: (e) => {
    const a = e.getDay();
    return "'" + (a === 0 || a === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, ec = (e, a, t, n) => {
  const r = Kl[e];
  return typeof r == "function" ? r(a) : r;
}, tc = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, ac = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, nc = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, rc = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, oc = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, ic = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, sc = (e, a) => Number(e) + "º", dc = {
  ordinalNumber: sc,
  era: b({
    values: tc,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: ac,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: nc,
    defaultWidth: "wide"
  }),
  day: b({
    values: rc,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: oc,
    defaultWidth: "wide",
    formattingValues: ic,
    defaultFormattingWidth: "wide"
  })
}, lc = /^(\d+)(º|ª)?/i, cc = /\d+/i, mc = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, uc = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era comum)/i,
    /^(depois de cristo|era comum)/i
  ]
}, hc = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, fc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, pc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ab/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, yc = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, vc = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, bc = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, Mc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, wc = {
  ordinalNumber: ce({
    matchPattern: lc,
    parsePattern: cc,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: mc,
    defaultMatchWidth: "wide",
    parsePatterns: uc,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: hc,
    defaultMatchWidth: "wide",
    parsePatterns: fc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: gc,
    defaultMatchWidth: "wide",
    parsePatterns: pc,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: yc,
    defaultMatchWidth: "wide",
    parsePatterns: vc,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: bc,
    defaultMatchWidth: "any",
    parsePatterns: Mc,
    defaultParseWidth: "any"
  })
}, Pc = {
  code: "pt",
  formatDistance: Jl,
  formatLong: Gl,
  formatRelative: ec,
  localize: dc,
  match: wc,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, kc = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Cc = (e, a, t) => {
  let n;
  const r = kc[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace("{{count}}", String(a)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "em " + n : "há " + n : n;
}, Ec = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, xc = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Dc = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Tc = {
  date: w({
    formats: Ec,
    defaultWidth: "full"
  }),
  time: w({
    formats: xc,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: Dc,
    defaultWidth: "full"
  })
}, Nc = {
  lastWeek: (e) => {
    const a = e.getDay();
    return "'" + (a === 0 || a === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, _c = (e, a, t, n) => {
  const r = Nc[e];
  return typeof r == "function" ? r(a) : r;
}, Sc = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Wc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, $c = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Oc = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, zc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, Lc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, Ac = (e, a) => {
  const t = Number(e);
  return (a == null ? void 0 : a.unit) === "week" ? t + "ª" : t + "º";
}, jc = {
  ordinalNumber: Ac,
  era: b({
    values: Sc,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: Wc,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: $c,
    defaultWidth: "wide"
  }),
  day: b({
    values: Oc,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: zc,
    defaultWidth: "wide",
    formattingValues: Lc,
    defaultFormattingWidth: "wide"
  })
}, Hc = /^(\d+)[ºªo]?/i, Rc = /\d+/i, Fc = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, Ic = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, Yc = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, qc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bc = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Xc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, Vc = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, Jc = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, Uc = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Qc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, Zc = {
  ordinalNumber: ce({
    matchPattern: Hc,
    parsePattern: Rc,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: Fc,
    defaultMatchWidth: "wide",
    parsePatterns: Ic,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Yc,
    defaultMatchWidth: "wide",
    parsePatterns: qc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Bc,
    defaultMatchWidth: "wide",
    parsePatterns: Xc,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Vc,
    defaultMatchWidth: "wide",
    parsePatterns: Jc,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: Uc,
    defaultMatchWidth: "any",
    parsePatterns: Qc,
    defaultParseWidth: "any"
  })
}, Gc = {
  code: "pt-BR",
  formatDistance: Cc,
  formatLong: Tc,
  formatRelative: _c,
  localize: jc,
  match: Zc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Kc = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, em = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
], tm = (e, a, t) => {
  let n;
  const r = Kc[e];
  return typeof r == "string" ? n = r : a === 1 ? n = r.one : n = r.other.replace(
    "{{count}}",
    a < 13 ? em[a] : String(a)
  ), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "om " + n : n + " sedan" : n;
}, am = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, nm = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, rm = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, om = {
  date: w({
    formats: am,
    defaultWidth: "full"
  }),
  time: w({
    formats: nm,
    defaultWidth: "full"
  }),
  dateTime: w({
    formats: rm,
    defaultWidth: "full"
  })
}, im = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, sm = (e, a, t, n) => im[e], dm = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, lm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, cm = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, mm = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, um = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, hm = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, fm = (e, a) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
      case 2:
        return t + ":a";
    }
  return t + ":e";
}, gm = {
  ordinalNumber: fm,
  era: b({
    values: dm,
    defaultWidth: "wide"
  }),
  quarter: b({
    values: lm,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: b({
    values: cm,
    defaultWidth: "wide"
  }),
  day: b({
    values: mm,
    defaultWidth: "wide"
  }),
  dayPeriod: b({
    values: um,
    defaultWidth: "wide",
    formattingValues: hm,
    defaultFormattingWidth: "wide"
  })
}, pm = /^(\d+)(:a|:e)?/i, ym = /\d+/i, vm = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, bm = {
  any: [/^f/i, /^[ev]/i]
}, Mm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, wm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Pm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, km = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Cm = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, Em = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, xm = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, Dm = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, Tm = {
  ordinalNumber: ce({
    matchPattern: pm,
    parsePattern: ym,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: M({
    matchPatterns: vm,
    defaultMatchWidth: "wide",
    parsePatterns: bm,
    defaultParseWidth: "any"
  }),
  quarter: M({
    matchPatterns: Mm,
    defaultMatchWidth: "wide",
    parsePatterns: wm,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: M({
    matchPatterns: Pm,
    defaultMatchWidth: "wide",
    parsePatterns: km,
    defaultParseWidth: "any"
  }),
  day: M({
    matchPatterns: Cm,
    defaultMatchWidth: "wide",
    parsePatterns: Em,
    defaultParseWidth: "any"
  }),
  dayPeriod: M({
    matchPatterns: xm,
    defaultMatchWidth: "any",
    parsePatterns: Dm,
    defaultParseWidth: "any"
  })
}, Nm = {
  code: "sv",
  formatDistance: tm,
  formatLong: om,
  formatRelative: sm,
  localize: gm,
  match: Tm,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, j = {
  da: Qo,
  de: Ei,
  enAU: Zi,
  enCA: rs,
  enGB: ls,
  enIN: fs,
  enNZ: bs,
  enUS: Cs,
  enZA: Ns,
  es: id,
  fr: Ld,
  it: yl,
  nl: Xl,
  pt: Pc,
  ptBR: Gc,
  sv: Nm
}, tt = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: j.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: j.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: j.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: j.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: j.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: j.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: j.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: j.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: j.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: j.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: j.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, ia = (e, a) => e ? vo(
  e,
  tt[a].dateProperties.timezone,
  tt[a].dateProperties.format.timeDateFull,
  {
    locale: tt[a].dateProperties.locale
  }
) : "", sa = (e, a, t) => {
  t && t.startsWith("http") && (t = t.replace(/^http:/, "https:"));
  const n = t || "https://www.oddschecker.com", r = a.toLowerCase(), o = e.startsWith("/") ? e.slice(1) : e;
  return `${n}/${r}/${o}`;
}, _m = "_imageContainer_p8mnt_1", Sm = "_overlay_p8mnt_18", Wm = "_focusTopLeft_p8mnt_36", $m = "_focusTopCenter_p8mnt_40", Om = "_focusTopRight_p8mnt_44", zm = "_focusCenterLeft_p8mnt_48", Lm = "_focusCenter_p8mnt_48", Am = "_focusCenterRight_p8mnt_56", jm = "_focusBottomLeft_p8mnt_60", Hm = "_focusBottomCenter_p8mnt_64", Rm = "_focusBottomRight_p8mnt_68", Fm = "_noOverlay_p8mnt_72", re = {
  imageContainer: _m,
  overlay: Sm,
  focusTopLeft: Wm,
  focusTopCenter: $m,
  focusTopRight: Om,
  focusCenterLeft: zm,
  focusCenter: Lm,
  focusCenterRight: Am,
  focusBottomLeft: jm,
  focusBottomCenter: Hm,
  focusBottomRight: Rm,
  noOverlay: Fm
}, da = ({
  alt: e,
  focusArea: a = "CENTER",
  imageContainerClass: t = re.imageContainer,
  imageOverlayClass: n = re.overlay,
  showOverlay: r = !1,
  url: o
}) => /* @__PURE__ */ F("div", { "aria-label": e, className: `${t} ${((s) => ({
  BOTTOM_CENTER: re.focusBottomCenter,
  BOTTOM_LEFT: re.focusBottomLeft,
  BOTTOM_RIGHT: re.focusBottomRight,
  CENTER: re.focusCenter,
  CENTER_LEFT: re.focusCenterLeft,
  CENTER_RIGHT: re.focusCenterRight,
  TOP_CENTER: re.focusTopCenter,
  TOP_LEFT: re.focusTopLeft,
  TOP_RIGHT: re.focusTopRight
})[s] || re.focusCenter)(a)}`, "data-testid": "article-image", children: [
  /* @__PURE__ */ u("img", { alt: e || "background image", src: o }),
  /* @__PURE__ */ u("div", { className: `${n} ${r ? "" : re.noOverlay}` })
] }), Im = "_lockBanner_pz94h_1", Ym = {
  lockBanner: Im
};
function qm(e) {
  return /* @__PURE__ */ u(
    "svg",
    {
      fill: "none",
      height: "100%",
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 18 21",
      width: "18",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u(
        "path",
        {
          d: "M9 12V14.25M0.75 8.25V19.5H17.25V8.25H0.75ZM3.75 8.25C3.75 3.75 3.75 0.75 9 0.75C14.25 0.75 14.25 3.75 14.25 8.25H3.75Z",
          stroke: "#00182E",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2"
        }
      )
    }
  );
}
const Bm = ({ isLoggedIn: e }) => /* @__PURE__ */ u("div", { className: Ym.lockBanner, children: e ? /* @__PURE__ */ u("span", { "data-testid": "unlocked-header", children: "unlocked" }) : /* @__PURE__ */ F("span", { "data-testid": "locked-header", children: [
  /* @__PURE__ */ u(qm, {}),
  "log in to view for free"
] }) });
function Xm(e) {
  var a = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return a[t] === void 0 && (a[t] = e(t)), a[t];
  };
}
var Vm = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, at = /* @__PURE__ */ Xm(
  function(e) {
    return Vm.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Jm = function() {
  const a = Array.prototype.slice.call(arguments).filter(Boolean), t = {}, n = [];
  a.forEach((o) => {
    (o ? o.split(" ") : []).forEach((s) => {
      if (s.startsWith("atm_")) {
        const [, l] = s.split("_");
        t[l] = s;
      } else
        n.push(s);
    });
  });
  const r = [];
  for (const o in t)
    Object.prototype.hasOwnProperty.call(t, o) && r.push(t[o]);
  return r.push(...n), r.join(" ");
}, jt = Jm, Um = (e) => e.toUpperCase() === e, Qm = (e) => (a) => e.indexOf(a) === -1, la = (e, a) => {
  const t = {};
  return Object.keys(e).filter(Qm(a)).forEach((n) => {
    t[n] = e[n];
  }), t;
};
function Zm(e, a, t) {
  const n = la(a, t);
  if (!e) {
    const r = typeof at == "function" ? { default: at } : at;
    Object.keys(n).forEach((o) => {
      r.default(o) || delete n[o];
    });
  }
  return n;
}
var Gm = (e, a) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const t = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${t}' in the component '${a}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Km = 0;
function Ht(e) {
  let a = "";
  return process.env.NODE_ENV === "test" && (a += `mocked-styled-${Km++}`, e && e.__wyw_meta && e.__wyw_meta.className && (a += ` ${e.__wyw_meta.className}`)), (t) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(t))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const n = (o, i) => {
      const { as: s = e, class: l = a } = o, c = t.propsAsIs === void 0 ? !(typeof s == "string" && s.indexOf("-") === -1 && !Um(s[0])) : t.propsAsIs, d = Zm(c, o, [
        "as",
        "class"
      ]);
      d.ref = i, d.className = t.atomic ? jt(t.class, d.className || l) : jt(d.className || l, t.class);
      const { vars: p } = t;
      if (p) {
        const E = {};
        for (const O in p) {
          const z = p[O], S = z[0], W = z[1] || "", h = typeof S == "function" ? S(o) : S;
          Gm(h, t.name), E[`--${O}`] = `${h}${W}`;
        }
        const P = d.style || {}, N = Object.keys(P);
        N.length > 0 && N.forEach((O) => {
          E[O] = P[O];
        }), d.style = E;
      }
      return e.__wyw_meta && e !== s ? (d.as = s, ue(e, d)) : ue(s, d);
    }, r = mt ? mt(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const i = la(o, ["innerRef"]);
        return n(i, o.innerRef);
      }
    );
    return r.displayName = t.name, r.__wyw_meta = {
      className: t.class || a,
      extends: e
    }, r;
  };
}
var K = process.env.NODE_ENV !== "production" ? new Proxy(Ht, {
  get(e, a) {
    return e(a);
  }
}) : Ht;
const eu = /* @__PURE__ */ K("a")({
  name: "Item",
  class: "Item_i1vcrbsf",
  propsAsIs: !1
}), tu = /* @__PURE__ */ K("div")({
  name: "TitleContainer",
  class: "TitleContainer_t1dd2fjt",
  propsAsIs: !1
}), au = "imageContainer_i1w8upjg", nu = /* @__PURE__ */ K("div")({
  name: "Title",
  class: "Title_t1hmv483",
  propsAsIs: !1
}), ct = /* @__PURE__ */ K("div")({
  name: "Author",
  class: "Author_a5c7qfj",
  propsAsIs: !1
}), ru = /* @__PURE__ */ K("div")({
  name: "FlexWrapper",
  class: "FlexWrapper_fr1f9kd",
  propsAsIs: !1
}), ou = () => ct, iu = /* @__PURE__ */ K(ou())({
  name: "PublishedDate",
  class: "PublishedDate_p11oj3x9",
  propsAsIs: !0
}), su = () => ct, du = /* @__PURE__ */ K(su())({
  name: "ReadTime",
  class: "ReadTime_r1b6lu9v",
  propsAsIs: !0
}), lu = /* @__PURE__ */ K("p")({
  name: "Description",
  class: "Description_d1bzrkm8",
  propsAsIs: !1
}), cu = ({
  aiGeneratedId: e,
  authors: a = [],
  baseUrl: t,
  componentTags: n = [],
  description: r,
  image: o,
  isLoggedIn: i,
  publishedTime: s,
  readTime: l,
  repub: c,
  requestUrl: d,
  title: p,
  url: E
}) => {
  const P = () => {
    Xt({
      aiArticle: e ? "yes" : "no",
      articleName: p,
      event: Vt.ARTICLE_CLICK,
      tipsterName: a[0].fullName
    });
  }, N = ia(s, c), O = n.includes("TIPS_PREMIUM"), z = sa(E, c, t);
  return /* @__PURE__ */ F("div", { children: [
    O && /* @__PURE__ */ u(Bm, { isLoggedIn: i }),
    /* @__PURE__ */ F(eu, { "data-testid": "article-item", href: Ae(z, d), onClick: P, children: [
      o && /* @__PURE__ */ u(
        da,
        {
          alt: o.alt,
          focusArea: o.focusArea,
          imageContainerClass: au,
          url: Jt(o.url, 350)
        }
      ),
      /* @__PURE__ */ F(tu, { children: [
        /* @__PURE__ */ u(nu, { "data-testid": "article-title", children: p }),
        r && /* @__PURE__ */ u(lu, { "data-testid": "article-description", children: r }),
        /* @__PURE__ */ F(ru, { children: [
          /* @__PURE__ */ F("div", { children: [
            a.length && /* @__PURE__ */ u(ct, { "data-testid": "article-author", children: a[0].fullName }),
            s && /* @__PURE__ */ u(iu, { "data-testid": "article-published-time", children: N })
          ] }),
          /* @__PURE__ */ u("div", { children: l && /* @__PURE__ */ u(du, { "data-testid": "article-read-time", children: l }) })
        ] })
      ] })
    ] })
  ] });
}, mu = "_wrapper_1h6cv_3", uu = "_heroArticle_1h6cv_9", hu = "_imageContainer_1h6cv_21", fu = "_contentContainer_1h6cv_37", gu = "_overlay_1h6cv_48", pu = "_title_1h6cv_59", yu = "_metadata_1h6cv_68", vu = "_metadataLeft_1h6cv_75", bu = "_metadataRight_1h6cv_81", Mu = "_mobileTimestamp_1h6cv_87", wu = "_desktopTimestamp_1h6cv_96", Pu = "_readTime_1h6cv_100", ku = "_mobileAuthor_1h6cv_110", Cu = "_desktopAuthor_1h6cv_119", te = {
  wrapper: mu,
  heroArticle: uu,
  imageContainer: hu,
  contentContainer: fu,
  overlay: gu,
  title: pu,
  metadata: yu,
  metadataLeft: vu,
  metadataRight: bu,
  mobileTimestamp: Mu,
  desktopTimestamp: wu,
  readTime: Pu,
  mobileAuthor: ku,
  desktopAuthor: Cu
}, Eu = ({
  authors: e = [],
  baseUrl: a,
  deviceType: t,
  image: n,
  publishedTime: r,
  readTime: o,
  repub: i,
  requestUrl: s,
  title: l,
  url: c
}) => {
  var z, S, W, h;
  const d = () => {
    Xt({
      articleName: l,
      event: Vt.HERO_ARTICLE_VIEW,
      tipsterName: e[0].fullName
    });
  }, p = ia(r, i), E = ((z = e[0]) == null ? void 0 : z.shortName) || ((S = e[0]) == null ? void 0 : S.fullName) || "", P = ((W = e[0]) == null ? void 0 : W.fullName) || ((h = e[0]) == null ? void 0 : h.shortName) || "", N = t === "MOBILE" ? 500 : t === "TABLET" ? 800 : 1e3, O = sa(c, i, a);
  return /* @__PURE__ */ u(
    "a",
    {
      className: te.wrapper,
      "data-testid": "hero-article",
      href: Ae(O, s),
      onClick: d,
      children: /* @__PURE__ */ F("div", { className: te.heroArticle, children: [
        /* @__PURE__ */ u(
          da,
          {
            alt: n.alt,
            focusArea: n.focusArea,
            imageContainerClass: te.imageContainer,
            imageOverlayClass: te.overlay,
            showOverlay: !0,
            url: Jt(n.url, N)
          }
        ),
        /* @__PURE__ */ F("div", { className: te.contentContainer, children: [
          /* @__PURE__ */ u("h2", { className: te.title, "data-testid": "hero-article-title", children: l }),
          /* @__PURE__ */ F("div", { className: te.metadata, children: [
            /* @__PURE__ */ F("div", { className: te.metadataLeft, children: [
              /* @__PURE__ */ u("div", { className: te.mobileAuthor, "data-testid": "hero-article-author-short-name", children: E }),
              /* @__PURE__ */ u("div", { className: te.desktopAuthor, "data-testid": "hero-article-author-full-name", children: P }),
              /* @__PURE__ */ u("div", { className: te.mobileTimestamp, "data-testid": "hero-article-publish-time", children: p })
            ] }),
            /* @__PURE__ */ F("div", { className: te.metadataRight, children: [
              /* @__PURE__ */ u("span", { className: te.desktopTimestamp, "data-testid": "hero-article-publish-time-read-time", children: `${p} | ${o}` }),
              /* @__PURE__ */ u("span", { className: te.readTime, "data-testid": "hero-article-read-time", children: o })
            ] })
          ] })
        ] })
      ] })
    }
  );
};
function ca(e) {
  var a, t, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (a = 0; a < r; a++)
        e[a] && (t = ca(e[a])) && (n && (n += " "), n += t);
    } else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function xu() {
  for (var e, a, t = 0, n = "", r = arguments.length; t < r; t++)
    (e = arguments[t]) && (a = ca(e)) && (n && (n += " "), n += a);
  return n;
}
const Du = "_up_77ag3_1", Tu = "_down_77ag3_6", Nu = "_right_77ag3_11", _u = "_left_77ag3_16", Su = "_md_77ag3_21", Wu = "_sm_77ag3_26", $u = "_loading_77ag3_31", Ou = "_light_77ag3_39", zu = "_dark_77ag3_42", Rt = {
  up: Du,
  down: Tu,
  right: Nu,
  left: _u,
  md: Su,
  sm: Wu,
  loading: $u,
  light: Ou,
  dark: zu
}, Lu = ({ variant: e }) => /* @__PURE__ */ u("span", { className: xu(Rt.loading, Rt[e]), children: "" });
const Au = "pageLink_p5rg824", ju = "paginationBreak_pqpdg5d", Hu = "paginationBreakLink_p3x7g4w", Ru = "activePageLink_a1q216p", Fu = /* @__PURE__ */ K("div")({
  name: "Container",
  class: "Container_c1bvwa30",
  propsAsIs: !1
}), Iu = /* @__PURE__ */ K("div")({
  name: "Header",
  class: "Header_hq2cit",
  propsAsIs: !1
}), Yu = () => ({
  isHref: e
}) => e ? "underline" : "none", qu = /* @__PURE__ */ K("a")({
  name: "HeadingLink",
  class: "HeadingLink_hhcy2b8",
  propsAsIs: !1,
  vars: {
    "hhcy2b8-0": [Yu()]
  }
}), Bu = () => ({
  isCentered: e
}) => e ? "center" : "flex-start", Xu = /* @__PURE__ */ K("div")({
  name: "Footer",
  class: "Footer_fjszzm6",
  propsAsIs: !1,
  vars: {
    "fjszzm6-0": [Bu()]
  }
}), Vu = () => ({
  rows: e
}) => `repeat(${e}, auto)`, Ju = /* @__PURE__ */ K("div")({
  name: "ItemsContainer",
  class: "ItemsContainer_i16u1jk6",
  propsAsIs: !1,
  vars: {
    "i16u1jk6-0": [Vu()]
  }
}), Uu = /* @__PURE__ */ K("a")({
  name: "ArrowLink",
  class: "ArrowLink_a1ez9tjb",
  propsAsIs: !1
}), Qu = /* @__PURE__ */ K("button")({
  name: "LoadMoreButtonLink",
  class: "LoadMoreButtonLink_l79kqg5",
  propsAsIs: !1
}), Zu = {
  FIRST_ARTICLE: "FIRST_ARTICLE",
  NONE: "NONE"
}, Gu = ({
  articles: e,
  articlesPage: a,
  baseUrl: t,
  defaultFeaturedArticle: n,
  deviceType: r,
  featuredArticleId: o,
  hasNextPage: i,
  isLoading: s,
  isLoggedIn: l,
  limit: c,
  loadMoreArticles: d,
  moreArticlesPath: p,
  moreArticlesText: E = "More Picks",
  pagination: P,
  paginationNextLabel: N,
  paginationPrevLabel: O,
  repub: z,
  requestUrl: S,
  title: W,
  total: h,
  type: k
}) => {
  const x = "oddschecker", H = Math.ceil(h / (c ?? 10)), B = (f) => {
    const D = f.selected + 1, T = new URL(window.location.href);
    D === 1 ? T.searchParams.delete("articlesPage") : T.searchParams.set("articlesPage", D.toString()), window.location.href = Ae(T.toString());
  }, I = e.find((f) => f.id === o) || (n === Zu.FIRST_ARTICLE ? e[0] : null), $e = I ? e.filter((f) => f.id !== I.id) : e, Xe = () => p ? /* @__PURE__ */ F(Uu, { "data-testid": "more-articles-link", href: Ae(p, S), children: [
    E,
    /* @__PURE__ */ u("svg", { fill: "none", height: "10", viewBox: "0 0 11 10", width: "11", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ u(
      "path",
      {
        d: "M4.00003 0.757359L8.24267 5L4.00003 9.24264",
        stroke: "var(--cxy-color-interactive-secondary-subtle)",
        strokeWidth: "1.5"
      }
    ) })
  ] }) : null, y = () => i ? /* @__PURE__ */ u(Qu, { "data-testid": "more-articles-link", disabled: s, onClick: d, children: s ? /* @__PURE__ */ u(Lu, { variant: "light" }) : E }) : null;
  return /* @__PURE__ */ F(Fu, { "data-fpsm-theme": x, "data-testid": "more-articles", children: [
    I && /* @__PURE__ */ u(Eu, { ...I, baseUrl: t, deviceType: r, repub: z, requestUrl: S }),
    W && /* @__PURE__ */ u(Iu, { children: /* @__PURE__ */ u(
      qu,
      {
        "data-testid": "more-articles-title",
        href: p ? Ae(p, S) : void 0,
        isHref: !!p,
        title: W,
        children: W
      }
    ) }),
    /* @__PURE__ */ u(Ju, { rows: e.length, children: $e.map((f) => /* @__PURE__ */ ue(
      cu,
      {
        ...f,
        articleType: k,
        baseUrl: t,
        isLoggedIn: l,
        key: f.id,
        repub: z,
        requestUrl: S
      }
    )) }),
    P !== "NO_PAGINATION" && /* @__PURE__ */ F(Xu, { isCentered: !p, children: [
      P === "BOTTOM_PAGE_NUMBERS" && H > 1 && /* @__PURE__ */ u(
        On,
        {
          activeLinkClassName: Ru,
          breakClassName: ju,
          breakLabel: "...",
          breakLinkClassName: Hu,
          forcePage: a - 1,
          hrefAllControls: !0,
          hrefBuilder: (f, D, T) => {
            if (f < 1 || f === T + 1)
              return;
            if (f === 1) {
              if (typeof window < "u") {
                const g = new URL(window.location.href);
                g.searchParams.delete("articlesPage");
                const m = g.searchParams.toString();
                return m ? `${g.pathname}?${m}` : g.pathname;
              }
              const V = new URL(S);
              V.searchParams.delete("articlesPage");
              const ee = V.searchParams.toString();
              return ee ? `${V.pathname}?${ee}` : V.pathname;
            }
            if (typeof window < "u") {
              const V = new URL(window.location.href);
              return V.searchParams.set("articlesPage", String(f)), `${V.pathname}?${V.searchParams.toString()}`;
            }
            const se = new URL(S);
            return se.searchParams.set("articlesPage", String(f)), `${se.pathname}?${se.searchParams.toString()}`;
          },
          marginPagesDisplayed: 1,
          nextLabel: N,
          onPageChange: B,
          pageCount: H,
          pageLinkClassName: Au,
          pageRangeDisplayed: 1,
          previousLabel: O,
          selectedPageRel: null
        }
      ),
      P === "MORE_ARTICLES_LINKS" && p && /* @__PURE__ */ u(Xe, {}),
      P === "LOAD_MORE_BUTTON" && /* @__PURE__ */ u(y, {})
    ] })
  ] });
}, Ku = ({
  articlesPage: e,
  dataApiEndpoint: a,
  defaultFeaturedArticle: t,
  deviceType: n,
  featuredArticleId: r,
  isLoggedIn: o,
  moreArticlesPath: i,
  moreArticlesText: s,
  title: l,
  ...c
}) => {
  const [d, p] = Ft(100), E = Number.isFinite(e) && e > 0 ? e : 1, P = Qt(c), { data: N, fetchNextPage: O, hasNextPage: z, isFetchingNextPage: S } = Ma({
    getNextPageParam(k, x) {
      if (!(!k || k.length < c.limit))
        return x.length;
    },
    initialPageParam: E - 1,
    queryFn: async ({ pageParam: k }) => {
      const x = await Ut(
        a,
        {
          ...c,
          offset: k * c.limit
        },
        {
          logger: console
        }
      );
      return x ? (p(x.total), x.articles) : [];
    },
    queryKey: P,
    refetchOnMount: c.pagination === "BOTTOM_PAGE_NUMBERS" ? "always" : !1
    // this is to ensure that we get the articles total
  });
  if (!N || N.pages.flat().length === 0)
    return null;
  const h = N.pages.flat().filter((k) => k !== null);
  return /* @__PURE__ */ u(
    Gu,
    {
      articles: h,
      articlesPage: E,
      baseUrl: c.baseUrl,
      defaultFeaturedArticle: t,
      deviceType: n,
      featuredArticleId: r,
      hasNextPage: z,
      isLoading: S,
      isLoggedIn: o,
      limit: c.limit,
      loadMoreArticles: O,
      moreArticlesPath: i,
      moreArticlesText: s,
      offset: c.offset,
      pagination: c.pagination,
      repub: c.repub,
      requestUrl: c.requestUrl,
      title: l,
      total: d,
      type: c.type
    }
  );
};
var eh = /* @__PURE__ */ ((e) => (e.Insights = "INSIGHTS", e.Tips = "TIPS", e))(eh || {});
function th(e = {}) {
  var a;
  return new ba.QueryClient({
    ...e,
    defaultOptions: {
      ...e.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(t) {
          return t * 100;
        },
        ...(a = e.defaultOptions) == null ? void 0 : a.queries
      }
    }
  });
}
const ch = async (e, a) => {
  const t = th(), n = Number.isFinite(e.articlesPage) && e.articlesPage > 0 ? e.articlesPage : 1, r = Math.max(0, (n - 1) * e.limit);
  let o = 0;
  try {
    const c = {
      countryCode: e.countryCode,
      limit: e.limit,
      offset: r,
      pagination: e.pagination,
      repub: e.repub,
      requestUrl: e.requestUrl,
      subdivision: e.subdivision,
      topics: e.topics,
      type: e.type
    };
    await t.prefetchInfiniteQuery({
      getNextPageParam(d, p) {
        if (!(!d || d.length < e.limit))
          return p.length;
      },
      initialPageParam: n - 1,
      queryFn: async ({ pageParam: d = 0 }) => {
        const p = await Ut(
          a,
          {
            ...c,
            offset: d * e.limit
          },
          { nocache: e.nocache }
        );
        return p && (o = p.total), p.articles;
      },
      queryKey: Qt(c),
      staleTime: 1 / 0
    });
  } catch {
  }
  const i = wa(t), s = Math.ceil(o / e.limit), l = {
    articlesPerPage: e.limit,
    currentPage: n,
    hasNextPage: n < s,
    hasPrevPage: n > 1,
    totalArticles: o,
    totalPages: s
  };
  return {
    dehydratedState: i,
    paginationMeta: l
  };
}, ah = (e) => new Ea({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      retry: (a, t) => {
        var n;
        return ((n = t == null ? void 0 : t.response) == null ? void 0 : n.status) === 404 ? !1 : a < 2;
      },
      retryDelay: (a) => Math.min(1e3 * (a + 1), 3e3),
      staleTime: e ? 0 : 1 / 0
    }
  }
}), nh = ({ resetErrorBoundary: e }) => (va(() => {
  e();
}, [e]), null);
function mh({ dehydratedState: e, nocache: a, ...t }) {
  const [n] = Ft(() => {
    const r = ah(a);
    return Pa(r, e), r;
  });
  return /* @__PURE__ */ u(Aa, { children: /* @__PURE__ */ u(ka, { client: n, children: /* @__PURE__ */ u(Ca, { children: ({ reset: r }) => /* @__PURE__ */ u(
    Na,
    {
      fallbackRender: ({ resetErrorBoundary: o }) => /* @__PURE__ */ u(nh, { resetErrorBoundary: o }),
      onReset: r,
      children: /* @__PURE__ */ u(ja, { i18nInstance: t.i18n, children: /* @__PURE__ */ u(ya, { fallback: /* @__PURE__ */ u(Ra, {}), children: /* @__PURE__ */ u(Ku, { ...t }) }) })
    }
  ) }) }) });
}
export {
  eh as ArticleTypes,
  mh as MoreArticlesWithQuery,
  ch as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
